import type { TranslationShape } from './types';

export const de: TranslationShape = {
  portfolio: {
    tools: 'Filter & Sammelaktionen',
    search: 'Domains suchen',
    expiry: 'Bezahlt bis',
    status: 'Status',
    all: 'Alle',
    on: 'Aktiviert',
    off: 'Deaktiviert',
    expiry_all: 'Beliebiges Datum',
    expiry_expired: 'Abgelaufen',
    expiry_30: 'Nächste 30 Tage',
    expiry_90: 'Nächste 90 Tage',
    expiryHint: 'Die Daten berücksichtigen bezahlte Verlängerungen. Bereits abgelaufene Domains sind in den Zeitfenstern nicht enthalten.',
    count: '{{count}} von {{total}} Domains',
    reset: 'Filter zurücksetzen',
    exportFiltered: 'Gefilterte als CSV exportieren',
    exportSelected: 'Auswahl als CSV exportieren',
    selected: '{{count}} ausgewählt',
    selectFiltered: 'Alle gefilterten auswählen',
    clear: 'Auswahl aufheben',
    select: 'Auswählen',
    selectDomain: '{{domain}} auswählen',
    selectionHint: 'Bis zu {{limit}} Domains pro Aktion, auch über mehrere Seiten. Filteränderungen heben die Auswahl auf.',
    renew: 'Verlängerungen in den Warenkorb',
    enable: 'Automatische Verlängerung aktivieren',
    disable: 'Automatische Verlängerung deaktivieren',
    review: 'Ausgewählte Domains prüfen',
    renewHint: 'Pro geeigneter Domain ein Verlängerungsjahr in den Warenkorb legen. Endpreise prüfen und beim Checkout bezahlen; diese Aktion löst keine Zahlung aus.',
    enableHint: 'Künftige Verlängerungen werden über Ihre bestehende Zahlungseinrichtung abgerechnet. Jetzt wird keine Verlängerung bezahlt.',
    disableHint: 'Sie müssen diese Domains manuell verlängern, um sie zu behalten. Bezahlte Verlängerungen und offene Bestellungen bleiben unverändert.',
    priceAtCheckout: 'Preis im Warenkorb',
    confirm: 'Für diese Domains bestätigen',
    results: 'Ergebnisse',
    running: 'Domains werden verarbeitet…',
    finished: 'Verarbeitung abgeschlossen. Bitte prüfen Sie die Ergebnisse.',
    retry: 'Fehlgeschlagene erneut versuchen',
    checkout: 'Warenkorb prüfen',
    added: 'Im Warenkorb',
    updated: 'Automatische Verlängerung aktualisiert',
    failed: 'Anfrage fehlgeschlagen. Bitte erneut versuchen.',
    inactive: 'Nicht hier verwaltet; übersprungen',
    paid: 'Verlängerung bereits bezahlt; übersprungen',
    pending: 'Verlängerung wartet auf Zahlung; übersprungen',
    unchanged: 'Bereits eingestellt; übersprungen',
    inCart: 'Bereits im Warenkorb; übersprungen',
    result_success: 'Erfolgreich',
    result_failed: 'Fehlgeschlagen',
    result_skipped: 'Übersprungen',
    deleted: 'Gelöscht',
    transferred: 'Wegtransferiert',
    unknown: 'Unbekannt',
    previous: 'Zurück',
    next: 'Weiter',
    page: 'Seite {{page}} von {{pages}}',
    sort: 'Sortieren nach',
    sort_name: 'Domainname',
    sort_expiry: 'Frühestes Ablaufdatum',
    sort_latest: 'Spätestes Ablaufdatum',
  },
  common: {
    search: 'Suchen',
    add: 'Hinzufügen',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    close: 'Schliessen',
    confirm: 'Bestätigen',
    loading: 'Laden...',
    name: 'Name',
    email: 'E-Mail',
    password: 'Passwort',
    status: 'Status',
    type: 'Typ',
    value: 'Wert',
    valueOptional: 'Wert (Optional)',
    address: 'Adresse',
    city: 'Stadt',
    state: 'Kanton',
    country: 'Land',
    countryOrRegion: 'Land oder Region',
    phone: 'Telefon',
    phoneNumber: 'Telefonnummer',
    code: 'Code',
    comment: 'Kommentar',
    settings: 'Einstellungen',
    inUse: 'In Benutzung',
    inCart: 'Im Warenkorb',
    domain: 'Domain',
    zipCode: 'PLZ',
    yes: 'Ja',
    no: 'Nein',
    apply: 'Anwenden',
    verify: 'Verifizieren',
    individual: 'Einzelperson',
    company: 'Unternehmen',
    error: 'Fehler',
    default: 'Standard',
    total: 'Total',
    items: 'Artikel',
    coupon: 'Gutschein',
    remove: 'Entfernen',
    disable: 'Deaktivieren',
    enabled: 'Aktiviert',
    disabled: 'Deaktiviert',
    processing: 'Verarbeitung...',
    saveChanges: 'Änderungen speichern',
    openMenu: 'Menü öffnen',
    paid: 'Bezahlt',
    free: 'Kostenlos',
    subtotal: 'Zwischensumme',
    discount: 'Rabatt',
    amountDue: 'Fälliger Betrag',
    product: 'Produkt',
    quantity: 'Menge',
    totalCost: 'Gesamtkosten',
    actions: 'Aktionen',
    pay: 'Bezahlen',
    host: 'Host',
    destination: 'Ziel',
    hostname: 'Hostname',
    created: 'Erstellt',
    notFoundDescription: 'Die Seite, die Sie suchen, muss noch programmiert werden.',
    goToHome: 'Zur Startseite',
    notAuthenticated: 'Nicht authentifiziert',
    toggleTheme: 'Thema wechseln',
    themeLight: 'Hell',
    themeDark: 'Dunkel',
    themeSystem: 'System',
    allSystemsNormal: 'Alle Systeme normal',
    systemNotNormal: 'Systemstörung',
    previous: 'Zurück',
    next: 'Weiter',
    page: 'Seite',
    rowsPerPage: 'Zeilen pro Seite',
    selectSection: 'Bereich auswählen',
    noResults: 'Keine Ergebnisse.',
    searchCountry: 'Land suchen...',
    noCountryFound: 'Kein Land gefunden.',
    searchState: 'Kanton suchen...',
    selectCountryFirst: 'Zuerst ein Land auswählen',
    price: 'Preis',
    faq: 'Häufig gestellte Fragen',
    perMonth: '/ Monat',
    perYear: '/ Jahr',
    overview: 'Übersicht',
    beta: 'Beta',
    expired: 'Abgelaufen',
    expiringSoon: 'Läuft bald ab',
  },
  nav: {
    domains: 'Domains',
    registration: 'Registrierung',
    transfer: 'Transfer',
    tldPrices: 'TLD-Preise',
    hosting: 'Hosting',
    websiteHosting: 'Website-Hosting',
    services: 'Dienste',
    docs: 'Docs',
    whoisLookup: 'Whois-Abfrage',
    whois: 'Whois',
    toggleMenu: 'Menü umschalten',
    legal: 'Rechtliches',
    termsOfService: 'Nutzungsbedingungen',
    domainRegistrationAgreement: 'Domain-Registrierungsvertrag',
    websiteHostingAgreement: 'Website-Hosting-Vertrag',
    dataProcessingAgreement: 'Datenverarbeitungsvertrag',
    privacyPolicy: 'Datenschutzrichtlinie',
    registrationDescription: 'Kaufen Sie eine neue Domain bei YourWebTech.',
    transferDescription: 'Transferieren Sie Ihre Domain zu YourWebTech.',
    tldPricesDescription: 'Überprüfen Sie die Preise der TLDs.',
    docsDescription: 'Lesen Sie Produktdokumentation und Hilfeseiten.',
  },
  auth: {
    login: 'Anmelden',
    signIn: 'Anmelden',
    signUp: 'Registrieren',
    createAccount: 'Konto erstellen',
    createAnAccount: 'Ein Konto erstellen',
    enterEmailToCreate: 'Geben Sie Ihre E-Mail-Adresse ein, um Ihr Konto zu erstellen',
    continueWithGoogle: 'Weiter mit Google',
    continueWithGitHub: 'Weiter mit GitHub',
    alreadyHaveAccount: 'Bereits ein Konto?',
    dontHaveAccount: 'Noch kein Konto?',
    resetPassword: 'Passwort zurücksetzen',
    emailAddress: 'E-Mail-Adresse',
    orYouCanAlso: 'Oder Sie können auch',
    forgotPassword: 'Passwort vergessen?',
    forgotPasswordTitle: 'Passwort vergessen',
    forgotPasswordDescription: 'Geben Sie Ihre E-Mail-Adresse ein. Wir senden Ihnen einen Link, mit dem Sie ein neues Passwort wählen können.',
    invalidCredentials: 'Ungültige Anmeldedaten',
    signInUnavailable: 'Die Anmeldung ist im Moment nicht möglich. Bitte versuchen Sie es in Kürze erneut.',
    accountCreated: 'Konto erstellt. Wir haben einen Bestätigungslink an {{email}} gesendet.',
    loggedOut: 'Erfolgreich abgemeldet',
    enterEmailToLogin: 'Geben Sie Ihre E-Mail-Adresse ein, um sich anzumelden',
    twoFactorAuth: 'Zwei-Faktor-Authentifizierung',
    twoFactorDescription: 'Geben Sie den 6-stelligen Code aus Ihrer Authenticator-App ein, um fortzufahren.',
    authenticationCode: 'Authentifizierungscode',
    twoFactorTitle: 'Zwei-Faktor-Authentifizierung (TOTP)',
    twoFactorProtect: 'Schützen Sie Ihr Konto, indem Sie bei der Anmeldung einen Einmalcode aus einer Authenticator-App verlangen.',
    twoFactorEnabled: 'Bei der Anmeldung wird ein Code aus Ihrer Authenticator-App abgefragt.',
    twoFactorEnableHint: 'Aktivieren Sie TOTP, um ein Geheimnis für Ihre Authenticator-App zu generieren (z. B. Google Authenticator, 1Password, Authy).',
    twoFactorScanQr: 'Scannen Sie diesen QR-Code in Ihrer Authenticator-App',
    twoFactorSecretKey: 'Geheimer Schlüssel (bei Bedarf manuell eingeben)',
    twoFactorVerificationCode: 'Bestätigungscode aus Ihrer Authenticator-App',
    twoFactorSixDigitCode: '6-stelliger Code',
    enable2fa: '2FA aktivieren',
    disable2fa: '2FA deaktivieren',
    verifyAndEnable: 'Verifizieren & aktivieren',
    disable2faTitle: 'Zwei-Faktor-Authentifizierung deaktivieren?',
    disable2faDescription: 'Bei der Anmeldung wird kein Bestätigungscode mehr abgefragt. Dies verringert die Sicherheit Ihres Kontos.',
    // Auth store toasts
    mfaSessionExpired: 'MFA-Sitzung abgelaufen. Bitte melden Sie sich erneut an.',
    noMfaFactor: 'Kein MFA-Faktor verfügbar.',
    mfaSignInError: 'Fehler beim Abschliessen der 2FA-Anmeldung.',
    mustBeSignedIn2fa: 'Sie müssen angemeldet sein, um 2FA zu aktivieren.',
    failedStart2fa: '2FA-Registrierung konnte nicht gestartet werden: ',
    totpSecretNotFound: 'TOTP-Geheimnis nicht gefunden. Bitte starten Sie die Registrierung erneut.',
    twoFactorEnabledToast: 'Zwei-Faktor-Authentifizierung aktiviert.',
    failedEnable2fa: '2FA konnte nicht aktiviert werden: ',
    mustBeSignedInDisable2fa: 'Sie müssen angemeldet sein, um 2FA zu deaktivieren.',
    noTotpEnabled: 'Kein TOTP-Faktor ist derzeit aktiviert.',
    twoFactorDisabled: 'Zwei-Faktor-Authentifizierung deaktiviert.',
    failedDisable2fa: '2FA konnte nicht deaktiviert werden: ',
    errorSigningUp: 'Ihr Konto konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
    exitImpersonation: 'Identitätswechsel beenden',
    showPassword: 'Passwort anzeigen',
    hidePassword: 'Passwort verbergen',
    passwordRule: {
      minLength: 'Mindestens 8 Zeichen',
      uppercase: 'Ein Grossbuchstabe',
      lowercase: 'Ein Kleinbuchstabe',
      number: 'Eine Zahl',
    },
    invalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    passwordRequired: 'Bitte geben Sie Ihr Passwort ein',
    passwordRequirementsNotMet: 'Das Passwort erfüllt noch nicht alle Anforderungen',
    tooManyAttempts: 'Zu viele Versuche. Bitte warten Sie einige Minuten oder setzen Sie Ihr Passwort zurück.',
    wrongEmailOrPassword: 'E-Mail-Adresse oder Passwort ist falsch.',
    noAccountYet: 'Neu hier?',
    createAccountWithEmail: 'Konto mit {{email}} erstellen',
    emailAlreadyRegistered: 'Mit dieser E-Mail-Adresse gibt es bereits ein Konto.',
    signInInstead: 'Stattdessen anmelden',
    errorSendingResetLink: 'Die E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es gleich nochmals.',
    sendResetLink: 'Link senden',
    checkYourInbox: 'Prüfen Sie Ihr Postfach',
    resetLinkSent: 'Falls es ein Konto für {{email}} gibt, haben wir dorthin einen Link zum Wählen eines neuen Passworts gesendet.',
    resetLinkHelp: 'Der Link ist 1 Stunde gültig. Nichts erhalten? Sehen Sie im Spam-Ordner nach oder prüfen Sie, ob Sie sich mit dieser Adresse registriert haben.',
    useDifferentEmail: 'Andere E-Mail-Adresse verwenden',
    backToSignIn: 'Zurück zur Anmeldung',
    emailConfirmed: 'E-Mail-Adresse bestätigt',
    emailConfirmedDescription: 'Vielen Dank. Wir verwenden diese Adresse für Ihre Rechnungen und Domain-Mitteilungen.',
    goToAccount: 'Zu Ihrem Konto',
    chooseNewPassword: 'Neues Passwort wählen',
    chooseNewPasswordFor: 'Für {{email}}',
    newPassword: 'Neues Passwort',
    saveAndSignIn: 'Speichern und anmelden',
    linkInvalid: 'Dieser Link ist nicht mehr gültig',
    verifyLinkInvalidDescription: 'Er ist möglicherweise abgelaufen oder wurde bereits verwendet. Ist Ihre E-Mail-Adresse noch nicht bestätigt, können Sie in Ihrem Konto einen neuen Link anfordern.',
    resetLinkInvalidDescription: 'Links zum Zurücksetzen funktionieren einmal und 1 Stunde lang. Fordern Sie einen neuen an, um Ihr Passwort zu wählen.',
    requestNewLink: 'Neuen Link anfordern',
    confirmEmailNotice: 'Bitte bestätigen Sie Ihre E-Mail-Adresse {{email}} mit dem Link, den wir Ihnen gesendet haben, damit unsere Rechnungen und Domain-Mitteilungen Sie erreichen.',
    verificationEmailResent: 'Wir haben einen neuen Link an {{email}} gesendet.',
    resendVerificationEmail: 'Link erneut senden',
    errorSendingVerificationEmail: 'Die E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es später erneut.',
  },
  domain: {
    batch: {
      single: 'Einzelne Domain',
      title: 'Sammeltransfer',
      description: 'Lade bis zu {{count}} .ch/.li-Domains mit ihren Transfercodes hoch oder füge sie ein.',
      nameservers: 'Deine bisherigen Nameserver bleiben bestehen. Falls dein bisheriger Anbieter auch dein DNS betreibt, prüfe, ob dieser Dienst nach dem Transfer weiterläuft.',
      upload: 'CSV hochladen',
      paste: 'Domains und Transfercodes einfügen',
      format:
        'Zwei Spalten: domain, auth_code. Kommas, Semikolons und Tabulatoren werden unterstützt; die Kopfzeile ist optional. Maximal 64 KB. Verwende für internationalisierte Namen die xn--Schreibweise.',
      preview: 'Domains anzeigen',
      review: 'Prüfe {{count}} Domains. Korrigiere oder entferne ungültige Zeilen und prüfe dann die Transferfähigkeit.',
      pricing: 'Preis pro Domain',
      transferPrice: 'Transfer:',
      renewalPrice: 'Verlängerung / Jahr:',
      checkoutPrice: 'Preisbestätigung im Checkout',
      check: 'Domains prüfen ({{count}})',
      add: 'Bereite Domains hinzufügen ({{count}})',
      startOver: 'Weitere Liste importieren',
      cartNotice:
        'Nur bereite Domains werden hinzugefügt. Prüfe die endgültigen Preise im Checkout, bevor du den Transfer bestätigst. Das Entfernen einer Vorschauzeile entfernt keine Domain aus deinem Warenkorb.',
      checkout: 'Weiter zum Warenkorb',
      working: 'Domains werden verarbeitet. Bitte lasse diese Seite geöffnet.',
      remove: 'Entfernen',
      removeRow: 'Zeile {{count}} entfernen',
      domainRow: 'Domain in Zeile {{count}}',
      codeRow: 'Transfercode in Zeile {{count}}',
      empty: 'Gib mindestens eine Domain und einen Transfercode ein.',
      tooLarge: 'Die Eingabe überschreitet 64 KB. Teile sie in kleinere Dateien auf.',
      tooMany: 'Ein Sammeltransfer darf höchstens {{count}} Domains enthalten. Teile deine Liste auf.',
      malformed: 'Die CSV-Datei enthält fehlerhafte Anführungszeichen. Prüfe die Felder und versuche es erneut.',
      columns: 'Jede Zeile muss genau zwei Spalten enthalten: domain und auth_code.',
      readFailed: 'Die Datei konnte nicht gelesen werden. Versuche es erneut oder füge den Inhalt ein.',
      invalidDomain: 'Gib eine gültige .ch- oder .li-Domain ohne URL oder Subdomain ein.',
      missingCode: 'Gib einen Transfercode ein.',
      invalidCode: 'Der Transfercode enthält einen Zeilenumbruch, ein Steuerzeichen oder mehr als 1024 Zeichen.',
      duplicate: 'Diese Domain kommt mehrfach vor. Entferne die doppelte Zeile.',
      inCart: 'Bereits in deinem Warenkorb.',
      unchecked: 'Noch nicht geprüft',
      checking: 'Wird geprüft…',
      ready: 'Bereit zum Hinzufügen',
      unavailable: 'Transfer nicht möglich. Prüfe den Code und den Status bei deinem bisherigen Registrar.',
      checkFailed: 'Die Prüfung ist fehlgeschlagen. Prüfe diese Domain erneut.',
      adding: 'Wird zum Warenkorb hinzugefügt…',
      added: 'Zum Warenkorb hinzugefügt',
      addFailed: 'Hinzufügen fehlgeschlagen. Versuche, diese Zeile erneut hinzuzufügen.',
    },
    domain: 'Domain',
    domainName: 'Domainname',
    creationDate: 'Erstellungsdatum',
    expirationDate: 'Ablaufdatum',
    autoRenewal: 'Automatische Verlängerung',
    autoRenew: 'Automatisch verlängern',
    registrar: 'Registrar',
    nameservers: 'Nameserver',
    nameserversAndDns: 'Nameserver & DNS-Einträge',
    nameserversTitle: 'Nameserver',
    nameserversDescription:
      'Standardmässig verwenden wir YWT-Nameserver für Ihre Domain. Sie können diese durch Ihre eigenen Nameserver ersetzen. In diesem Fall werden die DNS-Einträge von Ihren eigenen Nameservern verwaltet.',
    nameserversChanged: 'Nameserver erfolgreich geändert',
    urlForwarding: 'URL-Weiterleitung',
    rootHint: '@ für Root verwenden.',
    addToCart: 'In den Warenkorb',
    tooLong: 'Domain zu lang!',
    tooShort: 'Domain zu kurz!',
    port: 'Port',
    priority: 'Priorität',
    target: 'Ziel',
    ttl: 'TTL',
    weight: 'Gewicht',
    manageDomain: 'Domain verwalten',
    whoisPrivacy: 'Whois-Datenschutz',
    whoisPrivacyEnabled: 'Whois-Datenschutz ist standardmässig aktiviert. Ihre Kontaktdaten sind nicht öffentlich sichtbar.',
    dnssec: 'DNSSEC',
    dnssecFull: 'Domain Name System Security (DNSSEC)',
    dnssecUpdated: 'DNSSEC aktualisiert',
    dnssecRecordAdded: 'DNSSEC-Eintrag hinzugefügt',
    dnssecRecordRemoved: 'DNSSEC-Eintrag entfernt',
    acmeKeysTitle: 'Zertifikats-Automatisierung (ACME)',
    acmeKeysDescription:
      "Schlüssel für certbot, acme.sh oder lego, damit diese Let's-Encrypt- oder ZeroSSL-Zertifikate für diese Domain, auch Wildcards, per DNS-01-Challenge erneuern können. Ein Schlüssel kann nur TXT-Einträge unter _acme-challenge-Namen dieser Domain anlegen und entfernen.",
    acmeKeysEmpty: 'Noch keine Schlüssel.',
    acmeKeyCreate: 'Schlüssel erstellen',
    acmeKeyCreateHint: 'Der Schlüssel kann nur TXT-Einträge unter _acme-challenge-Namen dieser Domain anlegen und entfernen. Sein Geheimnis wird einmal angezeigt, direkt nach dem Erstellen.',
    acmeKeyLabel: 'Bezeichnung',
    acmeKeyLabelPlaceholder: 'Zum Beispiel: Webserver (optional)',
    acmeKeyUnnamed: 'Ohne Bezeichnung',
    acmeKeyName: 'Schlüsselname',
    acmeKeyCreated: 'Erstellt',
    acmeKeyRevoke: 'Widerrufen',
    acmeKeyRevokeTitle: 'Diesen Schlüssel widerrufen?',
    acmeKeyRevokeConfirm: 'Zertifikats-Tools, die ihn verwenden, können DNS nicht mehr ändern: Ihre nächste Erneuerung schlägt fehl, bis sie einen neuen Schlüssel erhalten.',
    acmeKeyLimit: 'Eine Domain kann bis zu {{count}} Schlüssel haben. Widerrufen Sie einen, um einen weiteren zu erstellen.',
    acmeKeyDocs: 'Anleitung',
    acmeKeyCreatedTitle: 'Schlüssel erstellt',
    acmeKeySecretOnce: 'Kopieren Sie das Geheimnis jetzt: Es wird nur dieses eine Mal angezeigt. Wenn Sie es verlieren, widerrufen Sie den Schlüssel und erstellen Sie einen neuen.',
    acmeKeyServer: 'Server',
    acmeKeyAlgorithm: 'Algorithmus',
    acmeKeySecret: 'Geheimnis',
    acmeKeySaveFile: 'Speichern Sie dies als {{path}}, nur für root lesbar:',
    acmeKeyThenRun: 'Dann ausführen:',
    acmeKeyRun: 'Ausführen:',
    acmeKeyDone: 'Fertig',
    acmeKeyCopy: 'Kopieren',
    acmeKeyCopied: 'Kopiert',
    acmeKeyCopyFailed: 'Kopieren nicht möglich. Markieren Sie den Text und kopieren Sie ihn von Hand.',
    acmeKeyCnameConflict:
      '_acme-challenge ist ein CNAME (auf {{target}}), daher können diese Schlüssel dort keine Challenge-Einträge schreiben. Löschen Sie diesen CNAME oben in den DNS-Einträgen, um sie für diese Domain zu verwenden.',
    dnssecYwtHint: 'Sie verwenden YWT-Nameserver. Sie können DNSSEC ganz einfach mit einem Klick aktivieren oder deaktivieren.',
    dnssecAdvanced: 'Erweiterte DNSSEC-Verwaltung',
    dnssecAdvancedHint: 'Verwalten Sie hier Ihre Domain-DS-Einträge (DNSSEC). Sie wissen, was Sie tun!',
    dnssecNoRecords: 'Keine DNSSEC-Einträge.',
    dnssecAddRecord: 'DNSSEC-Eintrag hinzufügen',
    dnssecProvideDs: 'DS-Eintragswerte angeben. Schlüsseldaten sind optional.',
    dnssecKeyTag: 'Schlüsselkennung',
    dnssecAlgorithm: 'Algorithmus',
    dnssecDigestType: 'Digest-Typ',
    dnssecDigest: 'Digest',
    dnssecHexDigest: 'Hex-Digest (max. 96 Zeichen)',
    dnssecIncludeKeyData: 'Schlüsseldaten einschliessen',
    dnssecOptional: '[optional]',
    dnssecFlags: 'Flags',
    dnssecProtocol: 'Protokoll',
    dnssecKeyAlgorithm: 'Schlüsselalgorithmus',
    dnssecPublicKey: 'Öffentlicher Schlüssel',
    dnssecBase64Key: 'Base64-Schlüssel',
    dnssecFixedProtocol: 'Fest: 3',
    dnssecKeyDataRequired: 'Erforderlich, wenn Schlüsseldaten enthalten sind',
    dnssecFillRequired: 'Bitte füllen Sie keyTag, Algorithmus, digestType und Digest aus',
    dnssecKeyTagRange: 'keyTag muss zwischen 0 und 65535 liegen',
    dnssecDigestMax: 'Digest darf maximal 96 Zeichen lang sein',
    dnssecKeyDataFieldsRequired: 'Flags, Protokoll, Schlüsselalgorithmus und öffentlicher Schlüssel sind erforderlich, wenn Schlüsseldaten enthalten sind',
    dnssecKeyTagLabel: 'Schlüssel-Tag:',
    dnssecAlgLabel: 'Alg.:',
    dnssecDigestTypeLabel: 'Digest-Typ:',
    dnssecDigestLabel: 'Digest:',
    dnssecSelect: 'Auswählen',
    dnssecAllowedAlgorithms: 'Erlaubt: 8, 10, 13, 14, 15, 16',
    dnssecAllowedDigestTypes: 'Erlaubt: 2 oder 4',
    searchTitle: 'Suche nach einer .ch/.li-Domain',
    searchDescription: 'Eine Domain zu registrieren war noch nie so einfach, übersichtlich und schnell.',
    searchPlaceholder: 'Finden Sie hier Ihre Traumdomain...',
    searchInfoTitle: 'Über .ch- und .li-Domains',
    searchInfoIntro:
      'YourWebTech ist ein akkreditierter Schweizer Registrar (SWITCH). Suchen Sie oben nach einem beliebigen .ch- oder .li-Namen, prüfen Sie die Verfügbarkeit und registrieren Sie ihn in wenigen Minuten — DNSSEC, volle DNS-Kontrolle und Whois-Datenschutz sind bei jeder Domain inbegriffen.',
    faqRegEligibilityQ: 'Wer kann eine .ch- oder .li-Domain registrieren?',
    faqRegEligibilityA: '.ch- und .li-Domains stehen allen weltweit offen — es gibt keine Wohnsitz- oder Ortsansässigkeitspflicht. Sie benötigen lediglich gültige Kontaktangaben.',
    faqRegSpeedQ: 'Wie lange dauert die Registrierung?',
    faqRegSpeedA:
      'Registrierungen laufen über die Schweizer Registrierungsstelle SWITCH und sind in der Regel innerhalb weniger Minuten abgeschlossen. Ihre Domain und das DNS lassen sich verwalten, sobald der Vorgang beendet ist.',
    faqRegDnssecQ: 'Sind DNSSEC und DNS-Verwaltung inbegriffen?',
    faqRegDnssecA: 'Ja. Jede Domain umfasst kostenloses DNSSEC, unsere Schweizer Nameserver und einen einfachen Editor für A-, AAAA-, CNAME-, MX-, TXT- und weitere Einträge — ohne Zusatzkosten.',
    faqRegTransferInQ: 'Kann ich eine Domain übertragen, die mir bereits gehört?',
    faqRegTransferInA: 'Ja — Sie können bestehende .ch- und .li-Domains kostenlos zu YourWebTech übertragen. Starten Sie auf der Transfer-Seite mit dem Auth-Code Ihrer Domain.',
    transferTitle: 'Eine .ch/.li-Domain transferieren',
    transferDescription: 'Genug vom Warten? Im Gegensatz zu anderen Registraren bieten wir <bold>sofortige</bold> Domain-Transfers.',
    transferNotAvailable: 'Domain ist nicht für den Transfer verfügbar',
    perYear: '/ Jahr',
    renewsAt: 'verlängert sich für',
    registration: 'Registrierung',
    renewal: 'Verlängerung',
    renewalDescription: 'Automatische Verlängerung verwalten und bei Bedarf eine Verlängerungsbestellung erstellen.',
    autoRenewalLabel: 'Automatische Verlängerung',
    autoRenewalHint: 'Erhalten Sie 30 Tage vor Ablauf eine Erinnerungs-E-Mail mit Zahlungslink.',
    autoRenewalEnabled: 'Automatische Verlängerung aktiviert',
    autoRenewalDisabled: 'Automatische Verlängerung deaktiviert',
    autoRenewalInfo:
      'Wenn aktiviert, erhalten Sie 30 Tage vor Ablauf eine automatische Belastung oder eine E-Mail-Erinnerung. Andernfalls besteht das Risiko des Ablaufs und Sie müssen manuell verlängern.',
    renewNow: 'Jetzt verlängern',
    renewNowHint: 'Erstellen Sie sofort eine Verlängerungsbestellung und bezahlen Sie direkt.',
    renewalAddedToCart: 'Verlängerung zum Warenkorb hinzugefügt',
    renewalOrderCreated: 'Verlängerungsbestellung bereit',
    renewalFeePaidTill: 'Verlängerungsgebühr bezahlt bis {{date}}',
    goToCart: 'Zum Warenkorb',
    noDomains: 'Noch keine Domains',
    noDomainsDescription: 'Sie haben noch keine Domains registriert.',
    copyNameservers: 'Nameserver kopieren',
    ywtNs: 'YourWebTech NS',
    ywtNsTooltip: 'YWT verwendet die folgenden DNS-Server für diese Domain: ',
    expires: 'Läuft ab:',
    dnsRecords: 'DNS-Einträge',
    dnsRecordsDescription: 'DNS-Einträge verweisen auf Dienste, die Ihre Domain nutzt, z. B. Weiterleitung Ihrer Domain oder Einrichtung eines E-Mail-Dienstes.',
    dnsOwnNameservers: 'Sie verwenden Ihre eigenen Nameserver.',
    dnsOwnNameserversHint: 'Sie können Ihre DNS-Einträge direkt bei Ihrem eigenen Nameserver-Anbieter verwalten.',
    dnsFailedToAdd: 'DNS-Eintrag konnte nicht hinzugefügt werden',
    dnsEditRecord: '{{type}}-Eintrag bearbeiten',
    dnsEditRecordHint: 'Nehmen Sie hier Änderungen am Eintrag vor. Klicken Sie auf Speichern, wenn Sie fertig sind.',
    dnsDeleteRecord: 'Eintrag löschen',
    dnsDeleteConfirm: 'Sie sind dabei, den folgenden Eintrag zu entfernen. Sind Sie sicher, dass Sie fortfahren möchten?',
    dnsAuto: 'Auto',
    dnsAutoTooltip: 'DNS-Einträge werden automatisch verwaltet',
    removeDomain: 'Domain entfernen',
    removeDomainDescription: 'Die Domain von Ihrem Konto entfernen.',
    removeDomainConfirm: 'Sind Sie sicher, dass Sie die Domain <strong>{{domain}}</strong> von Ihrem Konto entfernen möchten?',
    removeDomainIrreversible: 'Diese Aktion ist unwiderruflich und die Domain wird von Ihrem Konto gelöscht.',
    removeDomainSuccess: 'Domain von Ihrem Konto entfernt.',
    yesRemoveIt: 'Ja, entfernen',
    dangerZone: 'Gefahrenbereich',
    dangerZoneDescription: 'Funktionen, die Sie selten benötigen.',
    transferOut: 'Transfer hinaus',
    transferOutHint: 'Sie haben wohl versehentlich den falschen Button geklickt, oder? Wussten Sie, dass Sie Ihre Domain nicht transferieren müssen, um sie woanders zu hosten?',
    transferOutConfirm:
      'Wenn Sie jedoch sicher sind, dass Sie <strong>{{domain}}</strong> transferieren möchten, machen wir es Ihnen einfach und generieren einen neuen Auth-Code, den wir Ihnen per E-Mail zusenden.',
    transferOutSuccess: 'Wir haben Ihnen den Auth-Code per E-Mail gesendet.',
    transferOutNotAllowed: 'Transfer nicht erlaubt.',
    yesMadeUpMind: 'Ja, ich habe mich entschieden',
    transferProhibitedInfo: 'Die Domain ist derzeit nicht übertragbar. Wenn Sie die Domain gerade erst zu uns transferiert haben, ist dies normal.',
    transferredAwayBadge: 'Wegtransferiert',
    transferredAwayTitle: 'Diese Domain wurde zu einem anderen Registrar transferiert.',
    transferredAwayDescription: 'Sie wird nicht mehr von YourWebTech verwaltet und wird hier nur noch zur Information angezeigt. Sie können sie jederzeit aus Ihrem Konto entfernen.',
    deletedTitle: 'Diese Domain wurde gelöscht',
    deletedRestorable: 'Sie ist abgelaufen und wurde bei der Registry gelöscht. Website, E-Mail und andere Dienste darauf funktionieren nicht mehr. Sie können sie bis {{date}} wiederherstellen.',
    restoreIncludesYear: 'Der Preis enthält das nächste Jahr.',
    restoreKeepsDns: 'Ihre DNS-Einträge bleiben erhalten. Websites und URL-Weiterleitungen, die sie nutzten, müssen nach der Wiederherstellung neu hinzugefügt werden.',
    restoreAfterDeadline: 'Nach dem {{date}} kann sie jeder registrieren.',
    restoreDomainFor: 'Für {{price}} wiederherstellen',
    deletedNoLongerRestorable: 'Sie ist abgelaufen, wurde bei der Registry gelöscht und kann nicht mehr wiederhergestellt werden. Sobald die Registry sie freigibt, kann sie jeder neu registrieren.',
    deletedRestoreBySupport: 'Sie ist abgelaufen und wurde bei der Registry gelöscht. Um sie wiederherzustellen, kontaktieren Sie bitte unseren Support.',
    restorableUntilBadge: 'Gelöscht · wiederherstellbar bis {{date}}',
    deletedBadge: 'Gelöscht',
    oneYear: '1 Jahr',
    oneYearTooltip: 'Das Register erlaubt nur eine Registrierung von maximal einem Jahr. Aber keine Sorge, wir richten für jede Domain eine automatische Verlängerung ein, bis Sie diese kündigen.',
    // URL Forwarding
    urlForwardingTitle: 'URL-Weiterleitung',
    urlForwardingDescription: 'Leiten Sie Ihre Domain (und optionale Subdomains) auf eine andere Website weiter.',
    howForwardingWorks: 'Wie die Weiterleitung funktioniert',
    howForwardingWorksDescription:
      'Erstellen Sie unten eine oder mehrere Weiterleitungsregeln. Lassen Sie den Hostnamen leer, um die Root-Domain weiterzuleiten. Aktivieren Sie die Wildcard-Weiterleitung, um auch Subhosts weiterzuleiten. Die Weiterleitung wird normalerweise innerhalb weniger Minuten wirksam.',
    editRule: 'Regel bearbeiten',
    addNew: 'Neu hinzufügen',
    hostnameLabel: 'Hostname',
    blankForRoot: '(leer für Root)',
    hostnameExample: 'Beispiel: "www" leitet {{hostname}} weiter',
    forwardTrafficTo: 'Datenverkehr weiterleiten an',
    invalidUrlHint: 'Ungültige Eingabe. Muss mit http oder https beginnen',
    wildcardForwarding: 'Wildcard-Weiterleitung',
    wildcardForwardingHint: 'Auch Subhosts dieses Hostnamens weiterleiten',
    wildcardForwardingInfo:
      'Wenn aktiviert, leitet diese Regel auch Subhosts weiter. Beispiel: Hostname "abc" + Wildcard leitet sowohl "abc.{{host}}" als auch "*.abc.{{host}}" weiter (z. B. def.abc.example.com).',
    includePathLabel: 'Pfad einschliessen',
    includePathHint: 'Pfad + Query an das Ziel anhängen',
    includePathInfo: 'Wenn aktiviert, wird der angeforderte Pfad + Query (z. B. "/docs?x=1") an die Ziel-URL angehängt.',
    advancedLabel: 'Erweitert',
    advancedHint: 'Statuscode (Standard 307)',
    advancedInfo: 'Wählen Sie den Weiterleitungs-Statuscode. Standard ist 307 (temporär), um Methode und Body beizubehalten.',
    redirectType: 'Weiterleitungstyp',
    selectStatusCode: 'Statuscode auswählen',
    updateRule: 'Regel aktualisieren',
    addRule: 'Regel hinzufügen',
    currentForwards: 'Aktuelle Weiterleitungen',
    noForwards: 'Keine Weiterleitungen konfiguriert.',
    includePath: 'Pfad einschliessen',
    noPath: 'Kein Pfad',
    checking: 'Wird überprüft...',
    dnsOk: 'OK',
    dnsOkTooltip: 'DNS zeigt korrekt auf unsere Server',
    dnsMissing: 'Fehlt',
    dnsConfigRequired: 'DNS-Konfiguration erforderlich',
    dnsAutoAdded: 'Diese Einträge sollten automatisch hinzugefügt werden. Klicken Sie auf "Erneut prüfen", wenn sie nicht erscheinen.',
    dnsAddRecords: 'Fügen Sie die folgenden DNS-Einträge über Ihren DNS-Anbieter hinzu:',
    recheckDns: 'DNS erneut prüfen',
    sslActive: 'Aktiv',
    sslActiveTooltip: 'SSL-Zertifikat ist aktiv',
    sslWaitingForDns: 'Wartet auf DNS',
    sslWaitingForDnsTooltip: 'HTTPS startet automatisch, sobald DNS auf YourWebTech zeigt',
    sslIssuing: 'Wird ausgestellt',
    sslIssuingTooltip: 'Das SSL-Zertifikat wird ausgestellt, meist innerhalb einer Minute',
    editRuleTooltip: 'Regel bearbeiten',
    deleteRuleTooltip: 'Regel löschen',
    permanentRedirectWarning: 'Warnung: Permanente Weiterleitung',
    permanentRedirectBody: 'Sie sind dabei, eine <strong>permanente Weiterleitung ({{code}})</strong> zu erstellen.',
    permanentRedirectCacheWarning:
      'Browser und Suchmaschinen speichern permanente Weiterleitungen aggressiv im Cache. Wenn Sie einen Fehler machen, werden Benutzer möglicherweise weiterhin weitergeleitet, auch nachdem Sie die Regel entfernt haben.',
    permanentRedirectSuggestion: 'Verwenden Sie eine temporäre Weiterleitung (302 oder 307), wenn Sie testen oder die Regel später ändern möchten.',
    permanentRedirectConfirm: 'Ich verstehe, permanente Weiterleitung erstellen',
    forwardAdded: 'Weiterleitung hinzugefügt',
    forwardUpdated: 'Weiterleitung aktualisiert',
    forwardingRemoved: 'Weiterleitung entfernt',
    forwardRemoved: 'Weiterleitung entfernt',
    ruleEnabled: 'Regel aktiviert',
    ruleDisabled: 'Regel deaktiviert',
    transferDomainPlaceholder: 'Die zu transferierende Domain',
    authCodePlaceholder: 'Der Autorisierungscode',
    // Nameservers
    useYwtNameservers: 'YWT-Nameserver verwenden',
    useYwtNameserversDescription: 'Verwenden Sie unsere Standard-Nameserver, um Ihre DNS-Einträge automatisch zu verwalten.',
    defaultNameservers: 'Standard-Nameserver:',
    customNameservers: 'Benutzerdefinierte Nameserver:',
    noneConfigured: 'Keine konfiguriert',
    nameserver1: 'Nameserver 1',
    nameserver2: 'Nameserver 2',
    nameserver3Optional: 'Nameserver 3 (Optional)',
    nameserver4Optional: 'Nameserver 4 (Optional)',
    dnsCommentPlaceholder: 'Ein Kommentar, der erklärt, wofür dieser DNS-Eintrag dient.',
    dnsCommentDescription: 'Dies dient nur Ihrer Referenz und hat keinen Einfluss auf Ihren DNS-Eintrag.',
    // Domain pricing page
    pricingTitle: 'Domain-Preise',
    pricingSubtitle: 'Die Verlängerung kostet gleich viel wie die Registrierung, der Transfer ist kostenlos. Kein günstiges erstes Jahr, das danach teuer wird.',
    pricingHeadline: '{{price}} pro Jahr. Jedes Jahr.',
    compareTitle: 'Was eine .ch-Domain in {{years}} Jahren kostet',
    compareSubtitle: 'Viele Registrare vergünstigen das erste Jahr und holen es bei jeder Verlängerung wieder herein.',
    compareRegistrar: 'Registrar',
    compareFirstYear: 'Erstes Jahr',
    compareRenewal: 'Jede Verlängerung',
    compareTotal: '{{years}} Jahre',
    compareMoreThanUs: 'Teurer als YWT',
    compareFootnote: 'Preise inkl. Schweizer MWST, wie am {{date}} auf der Website des jeweiligen Registrars veröffentlicht. Total = erstes Jahr + eine Verlängerung für jedes weitere Jahr.',
    domainTld: 'Domain-TLD',
    vatNote: '*Preise inklusive 8,1 % Schweizer Mehrwertsteuer für Kunden in der Schweiz.',
    findYourDomain: 'Finden Sie Ihre Domain',
    whatsIncludedDomain: 'Was bei jeder Domain enthalten ist',
    ywtDnsServers: 'YWT-DNS-Server',
    dnssecSupportFeature: 'DNSSEC-Unterstützung',
    urlForwardingFeature: 'URL-Weiterleitung',
    easyDnsManagement: 'Einfache DNS-Verwaltung',
    greatUx: 'Hervorragende Benutzerfreundlichkeit',
    freeTransfers: 'Kostenlose Transfers',
    emailSupport: 'E-Mail-Support',
    noHiddenFees: 'Keine versteckten Gebühren',
    faqTrustQ: 'Kann ich Ihnen vertrauen?',
    faqTrustA:
      'Wir sind ein akkreditierter Registrar, der von der offiziellen Schweizer Registrierungsstelle \u2014 <switch>SWITCH</switch> \u2014 anerkannt ist. Dies sollte beweisen, dass wir unser Geschäft und unsere Kunden ernst nehmen.',
    faqVatQ: 'Wie wird die Mehrwertsteuer gehandhabt?',
    faqVatA:
      'Der angezeigte Preis ist für alle gleich. Schweizer Kunden haben 8,1 % Mehrwertsteuer im Preis inbegriffen (auf Rechnungen ausgewiesen). Kunden ausserhalb der Schweiz zahlen den gleichen Betrag, aber es fällt keine Schweizer Mehrwertsteuer an.',
    faqHiddenFeesQ: 'Gibt es versteckte Gebühren?',
    faqHiddenFeesA:
      'Nein. Unsere Preisgestaltung ist transparent. Was Sie sehen, ist das, was Sie bezahlen. Wir erheben keine zusätzlichen Einrichtungsgebühren, Servicegebühren oder sonstige Gebühren.',
    faqRenewalPriceQ: 'Ist der Verlängerungspreis derselbe wie der Registrierungspreis?',
    faqRenewalPriceA:
      'Ja, im Gegensatz zu vielen anderen Registraren, die Sie mit extrem günstigen Erstjahres-Registrierungsgebühren anlocken und dann den Verlängerungspreis verdreifachen, berechnen wir für die Verlängerung denselben Preis wie für die Registrierung.',
    faqTransfersQ: 'Berechnen Sie nichts für Domain-Transfers?',
    faqTransfersA: 'Richtig, wir berechnen Ihnen keine Gebühren für Domain-Transfers. Wir heissen alle Domain-Inhaber willkommen, sich uns anzuschliessen und unsere Dienste zu nutzen.',
    faqPaymentMethodsQ: 'Welche Zahlungsmethoden akzeptieren Sie?',
    faqPaymentMethodsA: 'Wir akzeptieren alle gängigen Kreditkarten (Visa, Mastercard, American Express). Weitere Zahlungsmethoden können in Zukunft geprüft und hinzugefügt werden.',
    faqPriceChangesQ: 'Können sich die Preise ändern?',
    faqPriceChangesA:
      'Viele Faktoren können den Preis einer Domain beeinflussen. Zum Beispiel kann <switch>SWITCH</switch> die Grosshandelskosten ändern, Infrastrukturkosten können schwanken usw. Aber wir versuchen, den Preis so zugänglich wie möglich zu halten.',
    faqRefundsQ: 'Kann ich eine Rückerstattung beantragen?',
    faqRefundsA:
      'Wenn eine Domain erfolgreich registriert oder verlängert wurde, können Sie keine Rückerstattung beantragen, da sie bereits bei <switch>SWITCH</switch> verarbeitet wurde. Wenn Ihre Domain-Registrierung, Ihr Transfer oder Ihre Verlängerung nicht abgeschlossen wurde, kontaktieren Sie bitte den Support und wir helfen Ihnen weiter.',
    faqMoreThanOneYearQ: 'Kann ich eine Domain für mehr als ein Jahr registrieren?',
    faqMoreThanOneYearA:
      'Es ist technisch nicht möglich, .ch/.li-Domains für mehr als ein Jahr zu registrieren. Die Registrierungsstelle <switch>SWITCH</switch> erlaubt nur eine Registrierung von maximal einem Jahr.',
    expirationRenewalTooltip: 'Das aktuelle Ablaufdatum der Domain ist {{registryDate}} im Register. Sie wird jedoch automatisch bis {{renewalDate}} verlängert.',
  },
  checkout: {
    paymentDetail: 'Zahlungsdetails',
    enterBillingAddress: 'Rechnungsadresse eingeben',
    editBillingAddress: 'Rechnungsadresse bearbeiten',
    payNow: 'Jetzt bezahlen',
    payOrder: 'Bestellung bezahlen',
    noPay: 'Ich muss nicht bezahlen',
    paymentSecureForm: 'Verwenden Sie das sichere Formular unten, um Ihre Zahlung abzuschliessen.',
    paymentFormUnavailable: 'Zahlungsformular nicht verfügbar',
    paymentFormUnavailableDescription: 'Stripe konnte nicht geladen werden. Prüfen Sie Inhaltsblocker oder Ihre Netzwerkverbindung und laden Sie diese Seite neu.',
    paymentMethodNotAvailable: 'Bitte teilen Sie uns mit, wenn Ihre bevorzugte Zahlungsmethode nicht verfügbar ist.',
    savePaymentMethod: 'Diese Zahlungsmethode für zukünftige Einkäufe speichern',
    termsAccept: '*Mit dieser Bestellung akzeptieren Sie unsere',
    termsOfService: 'Nutzungsbedingungen',
    privacyNotice: 'und bestätigen, dass Sie unsere',
    privacyPolicy: 'Datenschutzrichtlinie',
    unexpectedError: 'Ein unerwarteter Fehler ist aufgetreten.',
    paymentProcessingTitle: 'Ihre Zahlung wird bestätigt…',
    paymentProcessingDescription: 'Ihre Bestellung ist eingegangen und wir bestätigen die Zahlung. Das kann einige Sekunden dauern – Sie müssen nicht erneut bezahlen.',
    viewOrderStatus: 'Bestellstatus anzeigen',
    paymentFailedTitle: 'Ihre Zahlung ist nicht durchgegangen',
    paymentFailedDescription: 'Die Zahlung wurde abgelehnt oder nicht abgeschlossen, es wurde nichts belastet. Sie können es mit derselben oder einer anderen Zahlungsmethode erneut versuchen.',
    retryPayment: 'Erneut bezahlen',
    orderReview: 'Bestellübersicht',
    orderDescription: 'Hier ist eine Liste Ihrer Bestellpositionen. (Bestell-ID: {{orderId}})',
    finishOrder: 'Bestellung abschliessen',
    reviewAndPay: 'Überprüfen Sie Ihre Bestellung und fahren Sie mit der Zahlung fort.',
    emptyOrder: 'Diese Bestellung ist leer. Bitte löschen Sie diese Bestellung und suchen Sie erneut nach Domains.',
    domainsUnavailable: 'Einige Domains in dieser Bestellung sind nicht mehr verfügbar. Diese Bestellung ist ungültig. Bitte löschen Sie diese Bestellung und suchen Sie erneut nach Domains.',
    paymentMethods: 'Zahlungsmethoden',
    newPaymentMethod: 'Neue Zahlungsmethode',
    couponCode: 'Gutscheincode',
    vatExempt: '(Nicht der Schweizer MwSt. unterliegend)',
    vatIncluded: '(8.1% MwSt. inkl.)',
    websiteHosting: 'Website-Hosting',
    notApplicable: 'Nicht zutreffend',
    yourCart: 'Ihr Warenkorb',
    cartDescription: 'Starten Sie Ihre Web-Technologie von hier.',
    cartEmpty: 'Ihr Warenkorb ist leer.',
    addMoreToCart: 'Mehr in den Warenkorb',
    continueToCheckout: 'Weiter zur Kasse',
    goToCheckout: 'Zur Kasse',
    unpaidOrders: 'Aber Sie haben unbezahlte Bestellungen.',
    unpaidRenewalOrders: 'Unbezahlte Verlängerungsbestellungen:',
    viewAmountsDue: 'Fällige Beträge anzeigen',
    amountsDue: 'Fällige Beträge',
    amountsDueDescription: 'Prüfen Sie unbezahlte Verlängerungsbestellungen und bündeln Sie sie in einer Rechnung.',
    amountsDueEmpty: 'Derzeit gibt es keine unbezahlten Verlängerungsbestellungen.',
    payAllInOneInvoice: 'Alles in einer Rechnung bezahlen',
    renewalOrderDomainCount: '{{count}} Domain-Verlängerungspositionen',
    viewOrders: 'Bestellungen anzeigen',
    order: 'Bestellung',
    thankYou: 'Vielen Dank!',
    paymentReceived: 'Ihre Zahlung ist eingegangen.',
    freeOrderPlaced: 'Sie haben eine kostenlose Bestellung aufgegeben.',
    orderProcessing: 'Wir werden Ihre Bestellung bearbeiten und Ihnen innerhalb weniger Minuten eine Bestätigungs-E-Mail senden.',
    domainItems: 'Domain-Artikel:',
    amountPaid: 'Bezahlter Betrag:',
    amountRemaining: 'Verbleibender Betrag:',
    dateAndTime: 'Datum & Uhrzeit:',
    viewMyOrder: 'Meine Bestellung {{id}} anzeigen',
    goToMyWebsite: 'Zu meiner Website',
    goToMyWebsites: 'Zu meinen Websites',
    orderFrom: 'Bestellung {{id}} vom {{date}}',
    totalDue: 'Fälliger Gesamtbetrag',
    invoiceNumber: 'Rechnungsnummer',
    domainType: 'Domain {{type}}',
    deleteOrder: 'Bestellung löschen',
    deleteOrderConfirm: 'Sie sind dabei, die Bestellung {{id}} zu löschen. Sind Sie sicher, dass Sie fortfahren möchten?',
    orderDeletedSuccess: 'Bestellung erfolgreich gelöscht',
    oneYear: '1 Jahr',
    oneMonth: '1 Monat',
    upgradeToPlan: 'Auf {{plan}}-Plan upgraden',
    plan: '{{plan}}-Plan',
    days: '{{count}} Tage',
    daysUntilDate: '({{count}} Tage bis {{date}})',
    autoRenewMonthly: 'Sofern Sie nicht kündigen, wird Ihr Abonnement automatisch jeden Monat verlängert.',
    autoRenewYearly: 'Sofern Sie nicht kündigen, wird Ihr Abonnement automatisch jedes Jahr verlängert.',
    summary: 'Zusammenfassung',
    cartSummary: 'Ihre Warenkorbübersicht.',
    cart: 'Warenkorb',
    registrantAddress: 'Inhaberadresse',
    billingAddress: 'Rechnungsadresse',
    createOrder: 'Bestellung erstellen',
    cartEmptyWithOrders: 'Ihr Warenkorb ist leer. Haben Sie unfertige <link>Bestellungen</link>?',
    priceFreeFun: 'Nichts ist besser als gratis!',
    priceCoffee: 'Etwa der Preis eines Kaffees',
    priceBeer: 'Etwa der Preis eines Biers',
    priceLunch: 'Etwa der Preis eines einfachen Mittagessens',
    priceLunchMenu: 'Etwa der Preis eines Mittagsmenüs',
  },
  contact: {
    maintenance: {
      title: 'Registrantenkontakte',
      description: 'Verwalte die Personen oder Unternehmen, die als Domaininhaber eingetragen sind.',
      edit: 'Kontaktdaten bearbeiten',
      defaultContact: 'Standard für Bestellungen',
      saved: 'Kontaktdaten aktualisiert.',
      sharedNotice:
        'Diese Änderung aktualisiert den gemeinsamen Kontakt bei der Registry für alle Domains, die ihn verwenden, auch als technischen Kontakt. Verknüpfte Rechnungsdaten folgen dem Standardkontakt; bestehende Rechnungen bleiben unverändert. Für einen anderen Inhaber wähle Inhaber ändern in den Domaineinstellungen.',
      linkedDomains: 'Domains mit diesem Inhaber:',
      sameHolder: 'Ich bestätige, dass dies aktualisierte Angaben derselben Person oder desselben Unternehmens sind.',
      newContactNotice: 'Ein neuer Kontakt ändert weder bestehende Domaininhaber noch deinen Standardkontakt.',
      holderTitle: 'Domaininhaber',
      holderDescription: 'Wähle den Inhaber dieser Domain. Die Domain bleibt in deinem Konto. DNS, technischer Kontakt und Rechnungsdaten bleiben unverändert.',
      currentHolder: 'Aktueller Inhaber',
      currentUnavailable: 'Die Angaben zum aktuellen Inhaber fehlen. Bitte kontaktiere den Support.',
      newHolder: 'Neuer Inhaber',
      chooseHolder: 'Kontakt auswählen',
      noOtherContacts: 'Noch keine weiteren Kontakte vorhanden. Fügen Sie eine Registrantenadresse hinzu, um einen neuen Inhaber auszuwählen.',
      changeHolder: 'Inhaber ändern',
      holderNotice: 'Du änderst den eingetragenen Inhaber von {{domain}} auf den oben angezeigten Kontakt.',
      holderConfirmation: 'Ich bin vom aktuellen Inhaber zu dieser Änderung bevollmächtigt und bestätige das Einverständnis des neuen Inhabers.',
      holderSaved: 'Domaininhaber geändert.',
    },
    createRegistrant: 'Inhaber erstellen',
    registrantType: 'Inhabertyp',
    billingType: 'Rechnungstyp',
    companyContact: 'Unternehmen',
    companyName: 'Firmenname',
    vatId: 'USt-IdNr.',
    registrantContact: 'Inhaberkontakt',
    registrantContactRequired: 'Sie haben noch keinen Inhaberkontakt erstellt. Dies ist vom Register vorgeschrieben.',
    registrantContactInfo: 'Ihre Kontaktinformationen werden vom Register benötigt.',
    continueToCheckout: 'Weiter zur Kasse',
    sameAsRegistrant: 'Gleich wie die Inhaberadresse',
    legalNameDescription: 'Ihr offizieller Name, der beim Register gespeichert wird.',
    companyNameDescription: 'Firmenname, falls die Rechnung an ein Unternehmen geht.',
    companyNameRegistrantDescription: 'Firmenname, falls der Inhaber ein Unternehmen ist.',
    vatDescription: 'USt-IdNr. für Geschäftskunden (optional).',
    contactEmailDescription: 'Ihre Kontakt-E-Mail-Adresse.',
    enterPhoneNumber: 'Telefonnummer eingeben',
    realNamePlaceholder: 'Vollständiger Name',
    companyPlaceholder: 'Unternehmen',
    vatIdPlaceholder: 'CHE-123.456.789',
    streetAndNumber: 'Strasse und Hausnummer',
    additionalAddress: 'Zusätzliche Adressinformationen',
    state: 'Kanton',
    countryOrRegion: 'Land oder Region',
    vatIdLabel: 'USt-IdNr.:',
    addNewRegistrant: 'Neue Registrantenadresse hinzufügen',
  },
  account: {
    manageAccountSettings: 'Verwalten Sie Ihre Kontoeinstellungen.',
    myAccount: 'Mein Konto',
    account: 'Konto',
    orders: 'Bestellungen',
    domains: 'Domains',
    websiteHosting: 'Website-Hosting',
    logOut: 'Abmelden',
    admin: 'Admin',
    paymentMethods: 'Zahlungsmethoden',
    paymentMethodsDescription: 'Verwalten Sie Ihre gespeicherten Zahlungsmethoden.',
    noPaymentMethods: 'Keine gespeicherten Zahlungsmethoden.',
    setAsDefault: 'Als Standard festlegen',
    defaultPaymentMethodSet: 'Standard-Zahlungsmethode erfolgreich festgelegt',
    paymentMethodDeleted: 'Zahlungsmethode erfolgreich gelöscht',
    expires: 'Läuft ab {{month}}/{{year}}',
    default: 'Standard',
    // Avatar
    avatar: 'Avatar',
    avatarDescription: 'Möchten Sie ein Profilbild hinzufügen? Das können Sie hier tun.',
    removeAvatar: 'Avatar entfernen',
    uploadAvatar: 'Avatar hochladen',
    avatarUpdated: 'Avatar aktualisiert.',
    avatarUpdateFailed: 'Avatar konnte nicht aktualisiert werden.',
    avatarRemoved: 'Avatar entfernt.',
    selectValidImage: 'Bitte wählen Sie eine gültige Bilddatei.',
    avatarUploadHint: 'Laden Sie ein Bild mit bis zu 128x128 Pixeln hoch. Grössere Bilder werden verkleinert.',
    // Order overview
    orderTitle: 'Bestellung',
    orderFrom: 'vom {{date}}',
    openMenu: 'Menü öffnen',
    viewOrder: 'Bestellung anzeigen',
    pay: 'Bezahlen',
    paymentStatus: 'Zahlungsstatus:',
    invoiceStatusPaid: 'Bezahlt',
    invoiceStatusDraft: 'Entwurf',
    invoiceStatusOpen: 'Offen',
    invoiceStatusVoid: 'Storniert',
    invoiceStatusUncollectible: 'Uneinbringlich',
    discount: 'Rabatt:',
    total: 'Total:',
    notInitiated: '{{type}} nicht eingeleitet',
    waitingForRegistry: 'Warte auf Kommunikation mit dem Register',
    manageOrders: 'Bestellungen anzeigen und verwalten',
    noOrdersYet: 'Noch keine Bestellungen',
    noOrdersDescription: 'Sie haben noch keine Bestellungen aufgegeben.',
    // Profile
    manageYourDomains: 'Verwalten Sie Ihre Domains',
    validEmailAddress: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
    emailDescription: 'Ihre E-Mail-Adresse wird zum Anmelden und für Benachrichtigungen verwendet und kann nicht geändert werden.',
    displayName: 'Anzeigename',
    displayNameDescription: 'Bitte geben Sie Ihren vollständigen Namen oder einen bevorzugten Anzeigenamen ein.',
    displayNameHint: 'Bitte verwenden Sie maximal 32 Zeichen.',
    displayNamePlaceholder: 'Wie dürfen wir Sie nennen?',
    recoveryEmail: 'Wiederherstellungs-E-Mail',
    recoveryEmailDescription: 'Wir senden keine E-Mails an diese Adresse. Wir identifizieren Sie über diese E-Mail-Adresse, falls Sie den Zugang zu Ihrem Hauptkonto verlieren.',
    recoveryEmailHint: 'Bitte verwenden Sie eine gültige E-Mail-Adresse.',
    // Delete account
    deleteAccount: 'Konto löschen',
    deleteAccountDescription: 'Löschen Sie Ihr Konto und die damit verknüpften Daten endgültig. Dies kann nicht rückgängig gemacht werden.',
    deleteAccountBlockedDomains: 'Bei uns sind noch Domains auf Sie registriert. Transferieren Sie diese zuerst zu einem anderen Registrar oder löschen Sie sie:',
    deleteAccountBlockedOrder: 'Eine Ihrer Bestellungen wird noch verarbeitet. Bitte versuchen Sie es erneut, sobald sie abgeschlossen ist.',
    deleteAccountBlockedAdmin: 'Admin-Konten können hier nicht gelöscht werden.',
    deleteAccountBlockedImpersonation: 'Ein Konto kann nicht gelöscht werden, während es stellvertretend verwendet wird.',
    deleteAccountDialogTitle: 'Konto endgültig löschen?',
    deleteAccountDialogDescription: 'Dies kann nicht rückgängig gemacht werden. Wir löschen endgültig:',
    deleteAccountItemProfile: 'Ihr Profil, Ihr Login, Ihre Kontakte und gespeicherten Zahlungsmittel',
    deleteAccountItemOrders: 'Ihren Warenkorb und unbezahlte Bestellungen',
    deleteAccountItemDns: 'DNS-Zonen und URL-Weiterleitungen von entfernten oder wegtransferierten Domains',
    deleteAccountItemSites: 'Ihre Websites ({{count}}) mit allen Dateien, Deployments und eigenen Domains',
    deleteAccountItemSubscription: 'Ihr Hosting-Abonnement endet sofort und ohne Rückerstattung',
    deleteAccountRetention: 'Rechnungen zu abgeschlossenen Zahlungen ({{count}}) werden gemäss Schweizer Recht zehn Jahre aufbewahrt und danach gelöscht.',
    deleteAccountConfirmLabel: 'Geben Sie zur Bestätigung Ihre E-Mail-Adresse ein',
    deleteAccountReauth: 'Bitte melden Sie sich ab, wieder an und versuchen Sie es erneut, damit wir Ihre Identität bestätigen können.',
    deleteAccountSuccess: 'Ihr Konto wurde gelöscht.',
  },
  hosting: {
    createNewWebsite: 'Neue Website erstellen',
    createStaticSite: 'Statische Website erstellen',
    createStaticSiteDescription: 'Geben Sie einen Namen und eine Subdomain für Ihre Website an.',
    siteName: 'Website-Name',
    subdomain: 'Subdomain',
    siteNamePlaceholder: 'Landingpage, Portfolio, Blog usw.',
    subdomainPlaceholder: 'meine_seite',
    subdomainHint: '3-32 Zeichen: a-z, 0-9, _',
    creating: 'Wird erstellt...',
    createSite: 'Website erstellen',
    siteCreated: 'Website erstellt',
    nameRequired: 'Name ist erforderlich',
    nameMaxLength: 'Name darf maximal 64 Zeichen lang sein',
    subdomainMinLength: 'Subdomain muss mindestens 3 Zeichen lang sein',
    subdomainMaxLength: 'Subdomain darf maximal 32 Zeichen lang sein',
    subdomainCharsOnly: 'Nur a-z, 0-9 und _ sind erlaubt',
    noWebsitesYet: 'Noch keine Websites',
    noWebsitesDescription: 'Sie haben noch keine Websites erstellt. Erstellen Sie jetzt Ihre erste Website.',
    deleteSite: 'Website löschen',
    deleteSiteTitle: '"{{name}}" löschen?',
    deleteSiteDescription: 'Dadurch werden die Website, ihre benutzerdefinierten Domains und alle bereitgestellten Dateien dauerhaft entfernt. Diese Aktion kann nicht rückgängig gemacht werden.',
    deleting: 'Wird gelöscht...',
    siteDeleted: 'Website gelöscht',
    renameSiteDescription: 'Nur der Name ändert sich. Die Adresse Ihrer Website bleibt gleich.',
    siteRenamed: 'Website umbenannt',
    siteIconTitle: 'Symbol',
    siteIconHelp: 'Wird bei dieser Website in Ihrem Konto angezeigt; Besucher sehen es nicht. Klicken Sie auf das Symbol, um ein Bild auszuwählen (höchstens 500 KB).',
    redirectsNotForParked: 'Eine «Demnächst»-Seite hat keine Weiterleitungen.',
    deleteSiteSectionTitle: 'Diese Website löschen',
    publishingYourSite: 'Ihre Website wird veröffentlicht',
    savingFiles: 'Ihre Dateien werden gespeichert...',
    creatingNewVersion: 'Neue Version wird erstellt...',
    generatingPreview: 'Vorschau wird generiert...',
    makingItLive: 'Wird live geschaltet...',
    mayTakeFewSeconds: 'Dies kann einige Sekunden dauern...',
    siteIsLive: 'Ihre Website ist live!',
    redirectingToOverview: 'Weiterleitung zu Ihrer Website-Übersicht...',
    uploadZipArchive: 'ZIP-Archiv hochladen',
    uploadZipDescription: 'Laden Sie Ihre statische Website als .zip-Datei hoch. Die Dateien werden in Ihren Entwurf entpackt, wo Sie sie ansehen und bearbeiten können.',
    chooseZipFile: 'Bitte wählen Sie eine .zip-Datei.',
    onlyZipSupported: 'Nur .zip-Dateien werden unterstützt.',
    uploading: 'Wird hochgeladen...',
    uploadingWait: 'Bitte warten Sie, während Ihre Datei hochgeladen wird',
    extractingFiles: 'Dateien werden entpackt...',
    extractingToWorkspace: 'Ihre ZIP-Datei wird in Ihren Entwurf entpackt',
    uploadComplete: 'Upload abgeschlossen!',
    redirectingToEditor: 'Ihr Entwurf wird geöffnet...',
    uploadFailed: 'Upload fehlgeschlagen',
    tryAgain: 'Erneut versuchen',
    replaceExistingFiles: 'Vorhandene Dateien ersetzen?',
    existingFilesCount: 'Ihr Entwurf enthält <strong>{{count}}</strong> vorhandene Datei(en).',
    replaceAllWarning: 'Durch das Hochladen dieser ZIP-Datei werden <strong>alle vorhandenen Dateien ersetzt</strong>.',
    replaceAllFiles: 'Alle Dateien ersetzen',
    uploadAndExtract: 'Hochladen & entpacken',
    afterExtraction: 'Nach dem Entpacken können Sie Ihre Dateien vor der Veröffentlichung ansehen und bearbeiten.',
    filesExtracted: 'Dateien erfolgreich entpackt!',
    active: 'Aktiv',
    updated: 'Aktualisiert {{date}}',
    selectImageFile: 'Bitte wählen Sie eine Bilddatei',
    imageTooLarge: 'Bild muss kleiner als 500 KB sein',
    faviconUpdated: 'Favicon aktualisiert',
    faviconUpdateFailed: 'Favicon konnte nicht aktualisiert werden',
    clickToChangeFavicon: 'Klicken, um Favicon zu ändern',
    // Editor file tree
    files: 'Dateien',
    newFile: 'Neue Datei',
    newFolder: 'Neuer Ordner',
    uploadFiles: 'Dateien hochladen',
    rename: 'Umbenennen',
    moveTo: 'Verschieben nach...',
    noFilesYet: 'Noch keine Dateien',
    moveFile: 'Datei verschieben',
    moveFileDescription: 'Zielordner auswählen für',
    current: '(aktuell)',
    rootFolder: '/ (Stammverzeichnis)',
    // Editor code panel
    noFileSelected: 'Keine Datei ausgewählt',
    selectFileToEdit: 'Wählen Sie eine Datei zum Bearbeiten aus',
    modified: 'Geändert',
    download: 'Herunterladen',
    imagePreview: 'Bildvorschau',
    videoPreview: 'Videovorschau',
    audioPreview: 'Audiovorschau',
    pdfPreview: 'PDF-Vorschau',
    binaryFile: 'Binärdatei',
    cannotPreview: 'Dieser Dateityp kann hier nicht angezeigt werden.',
    downloadFile: 'Datei herunterladen',
    robotsTxtHint:
      'Vorschau-URLs geben immer <code class="bg-blue-500/20 px-1 rounded">Disallow: /</code> zurück, um die Indexierung durch Suchmaschinen zu verhindern. Ihre robots.txt funktioniert nach der Veröffentlichung korrekt.',
    // Editor empty state
    workspaceEmpty: 'Noch nichts hier',
    chooseHowToStart: 'Wählen Sie, wie Sie mit dem Erstellen Ihrer Website beginnen möchten',
    startFresh: 'Neu starten',
    startFreshDescription: 'Eine leere index.html erstellen',
    createPage: 'Seite erstellen',
    createPageDescription: 'Formular ausfüllen. Kein Code.',
    createPageFailed: 'Die Seite konnte nicht erstellt werden',
    advancedOptions: 'Erweitert',
    uploadFilesDescription: 'Dateien und Ordner hochladen',
    uploadZip: 'ZIP hochladen',
    uploadZipShortDescription: 'Ein .zip-Archiv entpacken',
    uploadWebsite: 'Website hochladen',
    uploadWebsiteDescription: 'Ein ZIP Ihrer Site oder die eine Datei, die Ihnen Ihr KI-Assistent gegeben hat.',
    chooseUploadFile: 'Wählen Sie eine .zip- oder .html-Datei.',
    onlyZipOrHtmlSupported: 'Nur .zip- und .html-Dateien werden unterstützt.',
    htmlTooLarge: 'Diese Datei ist zu gross. Das Limit ist {{limit}}.',
    htmlUploaded: 'Ihre Seite wurde als index.html gespeichert.',
    uploadWebsiteHint: 'Ein ZIP wird in Ihre Site entpackt. Eine einzelne .html-Datei wird Ihre Startseite (index.html).',
    htmlReplacesIndex: 'Diese Datei ersetzt Ihre aktuelle index.html. Ihre anderen Dateien bleiben erhalten.',
    uploadNoFileYet: 'Noch keine Datei? So bauen Sie eine mit ChatGPT oder Claude.',
    buildWithAssistant: 'Mit Ihrem KI-Assistenten bauen',
    buildWithAssistantDescription: 'Mit ChatGPT oder Claude, dann laden Sie die eine Datei hoch, die es Ihnen gibt.',
    aiCardTitle: 'Mit ChatGPT oder Claude bauen',
    aiCardDescription: 'Ihr KI-Assistent stellt Ihnen ein paar Fragen und baut Ihre Seite. Sie laden eine Datei hoch.',
    aiCardButton: 'So geht es',
    chooseTemplate: 'Vorlage auswählen',
    chooseTemplateDescription: 'Mit einem ansprechenden Design starten',
    loadFromVersion: 'Aus Version laden',
    loadFromVersionDescription: 'Von bestehender Version kopieren',
    beta: 'Beta',
    latest: 'Neueste',
    // Template gallery
    templateGalleryDescription: 'Starten Sie mit einer professionell gestalteten Vorlage und passen Sie diese an Ihre Bedürfnisse an',
    all: 'Alle',
    applying: 'Wird angewendet...',
    useThisTemplate: 'Diese Vorlage verwenden',
    preview: 'Vorschau',
    back: 'Zurück',
    needMoreTemplates: 'Mehr Vorlagen benötigt?',
    useTemplate: 'Vorlage verwenden',
    templateApplied: 'Vorlage "{{name}}" erfolgreich angewendet!',
    failedToApplyTemplate: 'Vorlage konnte nicht angewendet werden',
    // Deployments
    history: 'Verlauf',
    noVersionsYet: 'Noch keine Versionen. Bei jeder Veröffentlichung wird hier eine Version gespeichert.',
    publishedFromEditor: 'Aus Ihrem Entwurf veröffentlicht',
    fileUpload: 'Datei-Upload',
    zipUpload: 'ZIP-Upload',
    live: 'Live',
    updatedTime: 'Aktualisiert:',
    // Deployment page actions
    version: 'Version',
    failedToRestore: 'Diese Version konnte nicht wiederhergestellt werden.',
    versionNowLive: 'Version ist jetzt live!',
    failedToEditCopy: 'Diese Version konnte nicht zum Bearbeiten kopiert werden.',
    editCopyReady: 'Sie bearbeiten jetzt eine Kopie dieser Version.',
    versionDeleted: 'Version gelöscht',
    failedToDeleteVersion: 'Version konnte nicht gelöscht werden.',
    previewVersion: 'Versionsvorschau',
    editCopy: 'Kopie dieser Version bearbeiten',
    replaceDraftTitle: 'Entwurf ersetzen?',
    replaceDraftDescription: 'Damit werden alle Dateien in Ihrem Entwurf durch diese Version ersetzt. Nicht veröffentlichte Änderungen gehen verloren.',
    deleteVersion: 'Version löschen',
    deleteVersionTitle: 'Diese Version löschen?',
    deleteVersionDescription: 'Dadurch wird diese Version und ihre gespeicherten Dateien dauerhaft entfernt. Diese Aktion kann nicht rückgängig gemacht werden.',
    restoring: 'Wird wiederhergestellt...',
    restoreVersion: 'Diese Version wiederherstellen',
    downloadVersion: 'Diese Version herunterladen (ZIP)',
    // Share draft and download (Edit toolbar)
    downloadFiles: 'Dateien herunterladen',
    shareDraft: 'Entwurf teilen',
    shareDraftTitle: 'Entwurf teilen',
    shareDraftDescription: 'Alle mit dem Link sehen Ihren Entwurf, bis der Link abläuft. Unter Ihrer Domain im Internet ist er erst, wenn Sie veröffentlichen.',
    shareDraftDuration: 'Der Link funktioniert',
    shareDraft1d: '1 Tag',
    shareDraft7d: '7 Tage',
    shareDraft30d: '30 Tage',
    shareDraftCreate: 'Link erstellen',
    shareDraftLink: 'Link zu Ihrem Entwurf',
    shareDraftExpires: 'Läuft ab am {{date}}',
    shareDraftCopyManually: 'Der Link ist markiert: Kopieren Sie ihn mit Ctrl+C oder ⌘C.',
    copyLink: 'Kopieren',
    copied: 'Kopiert',
    stopSharing: 'Teilen beenden',
    stopSharingConfirm: 'Alle bisher erstellten Links funktionieren dann nicht mehr.',
    stopSharingDone: 'Ihre Entwurfslinks funktionieren nicht mehr.',
    // Deployment overview
    previewUrl: 'Vorschau-URL',
    domains: 'Domains',
    createdVia: 'Erstellt über',
    editor: 'Online bearbeitet',
    git: 'Git',
    madeLive: 'Live geschaltet',
    duration: 'Dauer',
    size: 'Grösse',
    buildFailed: 'Build fehlgeschlagen',
    versionPreview: 'Versionsvorschau',
    openPreview: 'Vorschau öffnen',
    currentlyLive: 'Derzeit live',
    connectedDomains: 'Verbundene Domains',
    // Deployment status
    statusReady: 'Bereit',
    statusFailed: 'Fehlgeschlagen',
    statusBuilding: 'Wird erstellt',
    statusUploaded: 'Hochgeladen',
    statusPending: 'Ausstehend',
    // Empty deployment
    versionNotFound: 'Version nicht gefunden',
    versionNotFoundDescription: 'Diese Version konnte nicht geladen werden. Sie wurde möglicherweise gelöscht oder es ist ein Fehler aufgetreten.',
    // Performance panel
    runAnalysis: 'Analyse starten',
    analyzing: 'Wird analysiert...',
    screenshot: 'Screenshot',
    performance: 'Leistung',
    // Files upload
    uploadFilesTitle: 'Dateien hochladen',
    uploadFilesDialogDescription: 'Laden Sie Dateien direkt in Ihren Entwurf hoch. Sie können diese vor der Veröffentlichung ansehen und bearbeiten.',
    selectAtLeastOneFile: 'Bitte wählen Sie mindestens eine Datei aus.',
    uploadedFilesSuccess: '{{count}} Datei(en) erfolgreich hochgeladen!',
    uploadFailedRetry: 'Upload fehlgeschlagen. Bitte versuchen Sie es erneut.',
    replaceExistingFilesQuestion: 'Vorhandene Dateien ersetzen?',
    existingFileCount: 'Ihr Entwurf enthält <strong>{{count}}</strong> vorhandene Datei(en).',
    uploadWillReplaceAll: 'Durch das Hochladen werden <strong>alle vorhandenen Dateien ersetzt</strong>.',
    clearingWorkspace: 'Entwurf wird geleert...',
    removingExistingFiles: 'Vorhandene Dateien werden entfernt',
    uploadingProgress: 'Wird hochgeladen... ({{current}}/{{total}})',
    pleaseWaitUploading: 'Bitte warten Sie, während Ihre Dateien hochgeladen werden',
    uploadLimitsExceeded: 'Upload-Limits überschritten',
    uploadLimitsDescription: 'Die ausgewählten Dateien überschreiten die Limits für einzelne Datei-Uploads.',
    tooManyFiles: 'Zu viele Dateien:',
    youSelected: 'Sie haben {{count}} Dateien ausgewählt, das Limit liegt bei {{max}} Dateien.',
    filesExceedSize: '{{count}} Datei(en) überschreiten das Grössenlimit von {{limit}}:',
    andMore: '...und {{count}} weitere',
    useZipUpload: 'Stattdessen ZIP-Upload verwenden',
    useZipUploadDescription:
      'Für das Hochladen vieler oder grosser Dateien komprimieren Sie Ihr Projekt in eine <strong>.zip</strong>-Datei und verwenden Sie die Option <strong>ZIP hochladen</strong>. Dies ist schneller und unterstützt grössere Projekte.',
    goBack: 'Zurück',
    selectFiles: 'Dateien auswählen',
    selectFolder: 'Ordner auswählen',
    filesSelected: '{{count}} Datei(en) ausgewählt',
    clearAll: 'Alle löschen',
    useZipForLarger: '<strong>Verwenden Sie ZIP-Upload</strong> für grössere Projekte.',
    selectFilesToUpload: 'Wählen Sie Dateien oder einen Ordner zum Hochladen in Ihren Entwurf',
    fileLimitsInfo: 'Limit: {{maxFiles}} Dateien, {{maxSize}} pro Datei. Für grössere Uploads verwenden Sie ZIP.',
    uploadCount: '{{count}} Datei(en) hochladen',
    upload: 'Hochladen',
    // Static site domains
    domainAdded: 'Domain hinzugefügt',
    domainAddedWithRedirect: 'www.{{domain}} hinzugefügt. {{domain}} wird automatisch auf www.{{domain}} weitergeleitet.',
    upgradeToAddDomains: 'Upgraden Sie, um benutzerdefinierte Domains hinzuzufügen',
    upgradeToAddDomainsWithCount: 'Upgraden Sie, um Domains hinzuzufügen ({{used}}/{{limit}})',
    addDomain: 'Domain hinzufügen',
    addDomainWithCount: 'Domain hinzufügen ({{used}}/{{limit}})',
    addADomain: 'Domain hinzufügen',
    enterDomainToMap: 'Geben Sie die Domain ein, die dieser Website zugeordnet werden soll.',
    domainSource: 'Domain-Quelle',
    buyADomain: 'Domain kaufen',
    myDomains: 'Meine Domains',
    thirdPartyDomains: 'Drittanbieter-Domains',
    myDomainsDnsHint: 'Wir kümmern uns automatisch um DNS und SSL-Zertifikat für Sie.',
    thirdPartyDnsHint: 'Nachdem Sie die Domain hinzugefügt haben, zeigen wir Ihnen die DNS-Einträge, die Sie bei Ihrem DNS-Anbieter anlegen.',
    subdomainOptional: 'Subdomain (optional)',
    selectADomain: 'Domain auswählen',
    noDomainsWithUs: 'Sie haben noch keine Domains bei uns.',
    saving: 'Wird gespeichert\u2026',
    addDomainButton: 'Domain hinzufügen',
    // Delete domain
    removeDomainTitle: '"{{hostname}}" entfernen?',
    removeDomainMapping: 'Dadurch wird die Domain-Zuordnung von dieser Website entfernt. Sie können sie später wieder hinzufügen.',
    domainRemoved: 'Domain entfernt',
    removing: 'Wird entfernt\u2026',
    // Analytics
    analytics: 'Statistiken',
    days7: '7 Tage',
    days30: '30 Tage',
    days90: '90 Tage',
    visitors: 'Besucher',
    pageViews: 'Seitenaufrufe',
    bandwidth: 'Bandbreite',
    visitorsAndPageViews: 'Besucher & Seitenaufrufe',
    topPages: 'Top-Seiten',
    views: 'Aufrufe',
    topReferrers: 'Top-Verweisquellen',
    countries: 'Länder',
    devices: 'Geräte',
    browsers: 'Browser',
    noData: 'Keine Daten',
    noPageData: 'Keine Seitendaten',
    noReferrerData: 'Keine Verweisdaten',
    noCountryData: 'Keine Länderdaten',
    vsPrevious: 'im Vergleich zum Vorzeitraum',
    noAnalyticsYet: 'Noch keine Statistikdaten',
    noAnalyticsDescription: 'Statistikdaten werden hier angezeigt, sobald Ihre Website Besucher erhält.',
    // Static sites page
    hostFastSecure: 'Hosten Sie schnelle, sichere Websites ohne Server.',
    upgradeToCreateMore: 'Upgraden Sie, um mehr zu erstellen',
    // Editor page
    takingLonger: 'Dauert länger als erwartet',
    uploadRunningFor: 'Der Upload läuft seit {{time}}.',
    extractionRunningFor: 'Die Extraktion läuft seit {{time}}.',
    cancelAndRetry: 'Sie können abbrechen und es mit einer kleineren Datei erneut versuchen.',
    cancelStartOver: 'Abbrechen & neu beginnen',
    pleaseWaitProcessing: 'Bitte warten Sie, während Ihre Dateien verarbeitet werden',
    elapsed: 'Vergangen: {{time}}',
    extractionFailed: 'Extraktion fehlgeschlagen',
    errorProcessingFiles: 'Beim Verarbeiten Ihrer Dateien ist ein Fehler aufgetreten.',
    troubleshootingTips: 'Tipps zur Fehlerbehebung:',
    tipZipNotCorrupted: 'Stellen Sie sicher, dass die ZIP-Datei nicht beschädigt ist',
    tipSmallerZip: 'Versuchen Sie es mit einer kleineren ZIP-Datei (unter 100 MB)',
    tipNoSpecialChars: 'Vermeiden Sie Sonderzeichen in Datei-/Ordnernamen',
    tipValidFiles: 'Stellen Sie sicher, dass die ZIP-Datei gültige statische Website-Dateien enthält',
    unsavedChangesTitle: 'Ungespeicherte Änderungen verwerfen?',
    unsavedChangesDiscard: 'Ihre Änderungen an dieser Datei wurden nicht gespeichert und gehen verloren.',
    discardChanges: 'Änderungen verwerfen',
    fileCountLabel: '{{count}} Datei(en)',
    fromVersion: 'Von Version #{{version}}',
    deleteFileConfirm: '"{{path}}" löschen?',
    deleteFileDescription: 'Es wird aus Ihrem Entwurf entfernt. Veröffentlichte Versionen sind davon nicht betroffen.',
    tooManyFilesInline: 'Zu viele Dateien ({{count}}/{{max}}).',
    filesExceedInline: '{{count}} Datei(en) überschreiten {{limit}}.',
    andMoreFiles: '...und {{count}} weitere Dateien',
    failedToLoadFile: 'Datei konnte nicht geladen werden',
    failedToLoadPreview: 'Dateivorschau konnte nicht geladen werden',
    fileSaved: 'Datei gespeichert',
    failedToSaveFile: 'Datei konnte nicht gespeichert werden',
    failedToCreateFile: 'Datei konnte nicht erstellt werden',
    folderCreated: 'Ordner erstellt',
    failedToCreateFolder: 'Ordner konnte nicht erstellt werden',
    fileDeleted: 'Datei gelöscht',
    failedToDeleteFile: 'Datei konnte nicht gelöscht werden',
    fileRenamed: 'Datei umbenannt',
    failedToRenameFile: 'Datei konnte nicht umbenannt werden',
    failedToCreateStarter: 'Starterdatei konnte nicht erstellt werden',
    workspaceInitialized: 'Entwurf aus der Version kopiert',
    failedToLoadDeployment: 'Laden aus Deployment fehlgeschlagen',
    publishStoppedSaveFailed: 'Ihre Änderungen konnten nicht gespeichert werden, daher wurde nichts veröffentlicht. Bitte versuchen Sie es erneut.',
    failedToPublish: 'Veröffentlichung fehlgeschlagen',
    workspaceCleared: 'Entwurf geleert',
    failedToClearWorkspace: 'Entwurf konnte nicht geleert werden',
    startOver: 'Neu beginnen',
    startOverTitle: 'Von vorne beginnen?',
    startOverDescription: 'Dadurch werden alle Dateien in Ihrem Entwurf gelöscht, damit Sie neu starten können. Ihre veröffentlichten Versionen werden nicht beeinflusst.',
    publish: 'Veröffentlichen',
    publishing: 'Wird veröffentlicht...',
    publishYourWebsite: 'Veröffentlichen Sie Ihre Website',
    filesTooLarge: 'Dateien zu gross',
    uploadMaxFiles: 'Sie können bis zu {{max}} Dateien gleichzeitig hochladen.',
    useZipForBulk: 'ZIP-Upload für Massendateien verwenden',
    useZipForBulkDescription:
      'Für das Hochladen vieler oder grosser Dateien verwenden Sie stattdessen die Option ZIP hochladen. Gehen Sie zur Website-Übersicht und verwenden Sie "ZIP hochladen", um Ihr gesamtes Projekt auf einmal hochzuladen.',
    goToOverview: 'Zur Übersicht',
    // Site overview page
    visitSite: 'Website besuchen',
    draft: 'Entwurf',
    liveUrl: 'Live-URL',
    noCustomDomain: 'Keine benutzerdefinierte Domain konfiguriert.',
    addOne: 'Hinzufügen',
    moreDomains: '+{{count}} weitere Domain(s)',
    previewOnly: 'Nur Vorschau',
    previewOnlyDescription: 'Diese Website sehen nur Personen mit dem Vorschau-Link. Veröffentlichen Sie sie, um eine öffentliche Adresse zu erhalten.',
    viewLive: 'Live ansehen',
    getStarted: 'Loslegen',
    getStartedDraftDescription: 'Erstellen Sie Ihre Seite und wählen Sie dann einen Plan, um sie zu veröffentlichen.',
    getStartedDescription: 'Noch ist nichts veröffentlicht. Erstellen Sie Ihre Seite und veröffentlichen Sie sie dann.',
    editYourPage: 'Seite bearbeiten',
    sitePreview: 'Website-Vorschau',
    historyLink_one: 'Verlauf ({{count}} Version)',
    historyLink_other: 'Verlauf ({{count}} Versionen)',
    visitorsLast30Days: 'Besucher, letzte 30 Tage',
    visitorsLast30DaysCount: 'Besucher, letzte 30 Tage: {{count}}',
    versionCount_one: '{{count}} Version',
    versionCount_other: '{{count}} Versionen',
    visitorsLast30DaysValue: '{{count}} in den letzten 30 Tagen',
    nextFinishTitle: 'Seite fertigstellen',
    nextFinishText: 'Ihre Seite ist noch nicht im Internet. Stellen Sie sie fertig und klicken Sie dann auf Veröffentlichen.',
    nextPublishTitle: 'Seite veröffentlichen',
    nextPublishText: 'Ihren Entwurf können Sie über seinen Vorschau-Link teilen. Wählen Sie einen Plan, um ihn ins Internet zu stellen.',
    nextConnectTitle: 'Domain verbinden',
    nextConnectText: 'Ihre Seite ist unter {{address}} live. Verbinden Sie Ihre eigene Domain, damit Besucher sie unter Ihrem Namen finden.',
    nextFinishConnectingTitle: 'Verbindung von {{hostname}} abschliessen',
    nextFinishConnectingText: 'Die Domain wartet auf ihre DNS-Einträge. Im Tab Domains sehen Sie, was einzutragen ist.',
    showDnsRecords: 'DNS-Einträge anzeigen',
    nextReplaceParkedTitle: 'Durch eine richtige Seite ersetzen',
    nextReplaceParkedText: 'Eine richtige Website braucht einen Plan.',
    nextReplaceParkedPlanText: 'Machen Sie aus Ihrer «Demnächst»-Seite eine richtige Seite, die Sie mit einem Formular bearbeiten.',
    replaceParkedButton: 'Ersetzen',
    replaceParkedDialogTitle: 'Durch eine richtige Seite ersetzen?',
    replaceParkedDialogText: 'Ihre «Demnächst»-Seite wird zu einer richtigen Seite, die Sie mit einem Formular bearbeiten. Sie zählt zu Ihrem Plan und geht sofort online.',
    replaceParkedConverting: 'Wird ersetzt...',
    seePlans: 'Pläne ansehen',
    // Coming-soon page on a domain registered at YWT
    putPageOnDomainTitle: 'Eine Seite auf {{domain}} stellen',
    putPageOnDomainText: 'Zeigen Sie Besuchern eine Seite, während Sie Ihre Website bauen. Kostenlos für Domains, die bei YWT registriert sind.',
    putPageOnDomainButton: 'Seite erstellen',
    putPageDialogTitle: 'Eine «Demnächst»-Seite für {{domain}}',
    putPageDialogDescription: 'Besucher von {{domain}} sehen diese Seite, bis Ihre Website bereit ist. Sie können sie jederzeit ändern.',
    putItOnline: 'Online stellen',
    puttingOnline: 'Wird online gestellt...',
    parkedHeadline: 'Überschrift',
    parkedMessage: 'Nachricht',
    parkedContactEmail: 'Kontakt-E-Mail (optional)',
    parkedDefaultMessage: 'Wir bauen etwas Besonderes.',
    parkedHeadlineRequired: 'Geben Sie eine Überschrift ein.',
    parkedMessageRequired: 'Geben Sie eine Nachricht ein.',
    parkedTooLong: 'Höchstens {{max}} Zeichen.',
    parkedEmailInvalid: 'Geben Sie eine gültige E-Mail-Adresse ein.',
    parkedEditTitle: 'Ihre «Demnächst»-Seite',
    parkedEditDescription: 'Besucher von {{domain}} sehen diese Seite. Beim Speichern gehen Ihre Änderungen online.',
    parkedDomainsNote: 'Diese Seite wird auf {{domain}} und www.{{domain}} angezeigt.',
    comingSoonBadge: '«Demnächst»-Seite',
    // Business page (a one-page website made from a form)
    businessEditTitle: 'Ihre Seite',
    businessEditDescription: 'Füllen Sie das Formular aus; die Vorschau zeigt Ihre Seite. «Speichern» behält Ihre Änderungen, «Veröffentlichen» stellt sie ins Internet.',
    businessName: 'Name',
    businessTagline: 'Slogan (optional)',
    businessAbout: 'Über uns (optional)',
    businessServices: 'Angebot (optional)',
    businessService: 'Angebot {{n}}',
    businessRemoveService: 'Angebot {{n}} entfernen',
    businessAddService: 'Angebot hinzufügen',
    businessHours: 'Öffnungszeiten (optional)',
    businessPhone: 'Telefon (optional)',
    businessEmail: 'E-Mail (optional)',
    businessAddress: 'Adresse (optional)',
    businessTheme: 'Farben',
    businessThemeLight: 'Hell',
    businessThemeDark: 'Dunkel',
    businessThemeWarm: 'Warm',
    businessThemeCool: 'Kühl',
    businessNameRequired: 'Geben Sie einen Namen ein.',
    businessPhoneInvalid: 'Nur Ziffern, Leerzeichen und + ( ) - verwenden.',
    businessPhoto: 'Foto (optional)',
    businessPhotoHint: 'JPEG, PNG oder WebP, bis 2 MB. Es wird sofort gespeichert.',
    businessPhotoShown: 'Ihr Foto steht oben auf der Seite.',
    businessPhotoChoose: 'Foto wählen',
    businessPhotoReplace: 'Foto ersetzen',
    businessPhotoRemove: 'Foto entfernen',
    businessPhotoWrongType: 'Wählen Sie ein JPEG-, PNG- oder WebP-Bild.',
    businessPhotoTooLarge: 'Das Foto ist grösser als 2 MB.',
    businessPhotoFailed: 'Das Foto konnte nicht gespeichert werden',
    businessPreviewTitle: 'Vorschau Ihrer Seite',
    businessPreviewEmpty: 'Hier erscheint die Vorschau.',
    businessPreviewUpdating: 'Wird aktualisiert...',
    businessSaved: 'Seite gespeichert',
    businessSaveFailed: 'Die Seite konnte nicht gespeichert werden',
    unsavedPageDiscard: 'Ihre Änderungen an dieser Seite wurden nicht gespeichert und gehen verloren.',
    businessPageBadge: 'Seite',
    // Custom domains page
    primaryDomainUpdated: 'Primäre Domain aktualisiert',
    failedToSetPrimary: 'Primäre Domain konnte nicht festgelegt werden',
    domainConnected: 'Verbunden',
    invalidConfiguration: 'Ungültige Konfiguration',
    pendingDns: 'DNS ausstehend',
    customDomains: 'Benutzerdefinierte Domains',
    customDomainsDescription: 'Verbinden Sie Ihre eigene Domain mit dieser Website',
    notLiveYetWarning: 'Diese Website ist noch nicht live. Die folgenden Domains werden nicht wirksam.',
    noCustomDomainsYet: 'Noch keine benutzerdefinierten Domains.',
    primary: 'PRIMÄR',
    refreshStatus: 'Status aktualisieren',
    setAsPrimary: 'Als primär festlegen',
    setAsPrimaryNotConnected: '(noch nicht verbunden)',
    setAsPrimaryNotForParked: '(nicht für eine «Demnächst»-Seite)',
    primaryLabel: '(Primär)',
    dnsConfigRequired: 'DNS-Konfiguration erforderlich',
    dnsConfigDescription: 'Fügen Sie den folgenden DNS-Eintrag bei Ihrem Domain-Anbieter hinzu, um den Besitz zu bestätigen.',
    dnsPropagationNote: 'DNS-Änderungen dauern in der Regel etwa eine halbe Stunde, können aber bis zu 48 Stunden benötigen. Wir prüfen automatisch alle 30 Sekunden.',
    // Hosting plans page
    plansTitle: 'Statisches Website-Hosting',
    plansSubtitle: 'Kein kompliziertes Setup. Keine versteckten Gebühren. Einfaches, schnelles, sicheres und zuverlässiges Hosting.',
    salesClosedTitle: 'Statisches Hosting wird nicht mehr angeboten',
    salesClosedDescription: 'Statisches Hosting wird Neukunden nicht mehr angeboten. Bestehende Abonnements laufen bis zu ihrem Enddatum weiter.',
    salesClosedLearnMore: 'Informationen zum statischen Hosting',
    siteLimitReached: 'Website-Limit erreicht',
    customDomainLimitReached: 'Limit für benutzerdefinierte Domains erreicht',
    tierPlan: '{{tier}}-Plan',
    alreadySubscribed: 'Sie haben bereits ein Abonnement für statisches Hosting.',
    manageYourPlan: 'Ihren Plan verwalten',
    featureHttpsTitle: 'HTTPS inklusive',
    featureHttpsDesc: 'Keine Zertifikate zu verwalten. Standardmässig sicher.',
    featureFastTitle: 'Schnelles Laden',
    featureFastDesc: 'Statische Seiten laden schnell, ohne auf Servercode zu warten.',
    featureDomainsTitle: 'Eigene Domains',
    featureDomainsDesc: 'Einfache Einrichtung für Ihre eigenen Domains.',
    featureSwissTitle: 'Schweizer Rechenzentrum',
    featureSwissDesc: 'Daten bleiben in der Schweizer Infrastruktur.',
    billingMonthly: 'Monatlich',
    billingYearly: 'Jährlich',
    savePercent: '{{percent}}% sparen',
    billedMonthly: 'monatlich abgerechnet',
    billedYearlyFor: 'jährlich abgerechnet für',
    noSubscriptionRequired: 'kein Abonnement oder Zahlung erforderlich',
    freeTrialDesc: 'Testen und erstellen Sie, bevor Sie sich entscheiden.',
    startForFree: 'Kostenlos starten',
    oneWebsite: '1 Website',
    embeddedEditor: 'Integrierter Code-Editor',
    fileZipUpload: 'Datei-/ZIP-Upload',
    previewLinkFeature: 'Vorschau-Link zum Teilen',
    publishNeedsPlanFeature: 'Veröffentlichen erfordert einen Plan',
    noCustomDomainFeature: 'Keine eigene Domain',
    publishOnStarter: 'Veröffentlichen Sie Ihre Website mit einer eigenen Domain mit Starter.',
    popularLabel: 'Beliebt',
    starterDesc: 'Alles, was Sie brauchen, um eine echte Website zu betreiben.',
    yourCurrentPlan: 'Ihr aktueller Plan',
    downgradeToStarter: 'Auf Starter downgraden',
    getStarter: 'Starter erhalten',
    featuresFromFree: 'Funktionen des kostenlosen Plans',
    oneCustomDomain: '1 eigene Domain',
    customDomainTooltip: 'Verwenden Sie Ihre eigene Domain (z. B. ihrname.ch). Domain-Registrierung nicht inbegriffen.',
    websiteAnalysis: 'Website-Analyse & Überwachung',
    fastSecureDeliveryFeature: 'Schnelle, sichere Auslieferung mit HTTPS',
    emailSupportFeature: 'E-Mail-Support',
    fourteenDayGuarantee: '14-Tage-Geld-zurück-Garantie',
    perfectForPersonal: 'Perfekt für persönliche Websites & kleine Unternehmen.',
    businessDesc: 'Für mehrere Websites und höhere Nutzung.',
    upgradeToBusinessButton: 'Auf Business upgraden',
    chooseBusiness: 'Business wählen',
    featuresFromStarter: 'Funktionen des Starter-Plans',
    upToFiveWebsites: 'Bis zu 5 Websites',
    upToTenDomains: 'Bis zu 10 eigene Domains',
    higherTraffic: 'Höherer Traffic',
    prioritySupport: 'Priorisierter E-Mail-Support',
    thirtyDayGuarantee: '30-Tage-Geld-zurück-Garantie',
    needMoreWebsites: 'Brauchen Sie mehr als 5 Websites? Kontaktieren Sie uns.',
    moneyBackTitle: 'Bis zu 30 Tage Geld-zurück-Garantie',
    moneyBackDesc: 'Innerhalb der Geld-zurück-Garantiezeit erstatten wir Ihnen den Betrag zurück, wenn Sie mit unserem Service nicht zufrieden sind. Ohne Fragen.',
    whatsIncludedAll: 'Was in allen Plänen enthalten ist',
    httpsIncludedFeature: 'HTTPS inklusive',
    managedDns: 'Verwaltetes DNS',
    noServerMaintenance: 'Keine Serverwartung',
    fairUseTraffic: 'Fair-Use-Traffic',
    noHiddenFeesFeature: 'Keine versteckten Gebühren',
    fairUseNote: 'Es gilt Fair Use. Wir kontaktieren Sie, bevor Limits erreicht werden.',
    faqWhatIsStaticQ: 'Was ist statisches Website-Hosting?',
    faqWhatIsStaticA:
      'Statisches Hosting liefert vorgefertigte HTML-, CSS- und JavaScript-Dateien direkt an Besucher aus. Es eignet sich perfekt für Landingpages, Portfolios, Dokumentationen, Blogs, die mit Tools wie Hugo, Jekyll oder Next.js (statischer Export) erstellt wurden, sowie Single-Page-Anwendungen (React, Vue usw.).',
    faqDynamicQ: 'Kann ich dynamische Inhalte wie PHP oder Datenbanken ausführen?',
    faqDynamicA:
      'Nein. Statisches Hosting liefert nur Dateien aus \u2014 es gibt keine serverseitige Verarbeitung. Wenn Sie PHP, Node.js-Backends oder Datenbanken benötigen, brauchen Sie eine andere Hosting-Lösung. Sie können jedoch externe APIs und serverlose Funktionen für dynamische Features verwenden.',
    faqCustomDomainQ: 'Wie verbinde ich meine eigene Domain?',
    faqCustomDomainA:
      'Nachdem Sie Ihre Website erstellt haben, gehen Sie zum Domains-Tab und fügen Sie Ihre Domain hinzu. Wir stellen DNS-Einträge zur Konfiguration bereit. Wenn Ihre Domain bei uns registriert ist, wird DNS automatisch eingerichtet. HTTPS-Zertifikate werden automatisch ausgestellt, sobald DNS konfiguriert ist.',
    faqDeployQ: 'Wie deploye ich meine Website?',
    faqDeployA: 'Bearbeiten Sie Ihre Seite direkt im Browser, laden Sie Dateien oder ein ZIP-Archiv hoch und klicken Sie dann auf Veröffentlichen. All das finden Sie in Ihrem Website-Dashboard.',
    faqHttpsQ: 'Ist HTTPS/SSL inklusive?',
    faqHttpsA:
      'Ja! Alle Websites erhalten kostenlos automatisch HTTPS-Zertifikate. Sobald das DNS Ihrer Domain korrekt konfiguriert ist, stellen wir Zertifikate für Sie aus und erneuern sie \u2014 keine manuellen Schritte erforderlich.',
    faqVatQ: 'Wie wird die Mehrwertsteuer gehandhabt?',
    faqVatA:
      'Der angezeigte Preis ist für alle gleich. Schweizer Kunden haben 8,1 % Mehrwertsteuer im Preis inbegriffen (auf Rechnungen ausgewiesen). Kunden ausserhalb der Schweiz zahlen den gleichen Betrag, aber es fällt keine Schweizer Mehrwertsteuer an.',
    faqRefundQ: 'Was ist die Geld-zurück-Garantie?',
    faqRefundA:
      'Wenn Sie innerhalb der Garantiezeit (14 Tage für Starter, 30 Tage für Business) nicht zufrieden sind, kontaktieren Sie uns und wir erstatten Ihnen den vollen Betrag \u2014 ohne Fragen.',
    faqFreePlanQ: 'Kann ich den kostenlosen Plan nutzen, um meine Website zu erstellen?',
    faqFreePlanA:
      'Ja. Mit dem kostenlosen Plan können Sie Ihre Seite erstellen und über einen Vorschau-Link teilen. Um sie unter Ihrer Domain im Internet zu veröffentlichen, brauchen Sie einen Plan.',
    faqUpgradeQ: 'Kann ich meinen Plan später upgraden?',
    faqUpgradeA: 'Ja. Sie können jederzeit von Starter auf Business upgraden. Wir berechnen die Differenz anteilig für den verbleibenden Zeitraum Ihres Abonnements.',
    faqFairUsageQ: 'Was ist die Fair-Use-Richtlinie?',
    faqFairUsageA:
      'Wir setzen keine harten Traffic-Limits, erwarten aber normale Website-Nutzung. Wenn Ihre Website ungewöhnliche Spitzen aufweist (z. B. viraler Traffic oder Missbrauch), kontaktieren wir Sie, bevor wir Massnahmen ergreifen. Die grosse Mehrheit der Websites kommt nie auch nur in die Nähe von Limits.',
    faqDataLocationQ: 'Wo wird meine Website gespeichert?',
    faqDataLocationA: 'Ihre Website-Dateien werden in einer Infrastruktur in Zürich, Schweiz, gespeichert.',
    faqAnalyticsQ: 'Bieten Sie Website-Analytik an?',
    faqAnalyticsA:
      'Ja! Wir bieten Leistungsanalysen, die die Ladegeschwindigkeit Ihrer Website, Core Web Vitals und Optimierungsvorschläge anzeigen. Und auch Besucheranalysen wie Seitenaufrufe, Besucher, Geräte, Browser, Verweisquellen, Länder usw.',
    faqSupportQ: 'Wie erhalte ich Support?',
    faqSupportA: 'Schreiben Sie uns an <email>support@ywt.ch</email>. Business-Plan-Kunden erhalten priorisierten Support mit schnelleren Antwortzeiten.',
    websiteFallback: 'Webseite',
    // Path redirects
    redirectsTitle: 'Pfad-Weiterleitungen',
    redirectsDescription: 'Leiten Sie einen bestimmten Pfad Ihrer Website auf eine andere URL weiter, auf dieser Website oder anderswo.',
    redirectsHowItWorksTitle: 'So funktionieren Pfad-Weiterleitungen',
    redirectsHowItWorksBody:
      "Regeln vergleichen den Pfad exakt ('/blog' entspricht auch '/blog/') und werden vor den Dateien Ihrer Website angewendet — eine Regel gilt auch, wenn unter diesem Pfad noch eine Datei existiert. Änderungen sind innerhalb von etwa einer Minute aktiv.",
    redirectFromLabel: 'Von Pfad',
    redirectToLabel: 'Weiterleiten zu',
    redirectFromHint: "Muss ein Pfad sein, der mit '/' beginnt, ohne Query oder Leerzeichen",
    redirectToHint: "Geben Sie eine absolute URL (https://…) oder einen Pfad auf dieser Website ein, der mit '/' beginnt",
    addRedirect: 'Weiterleitung hinzufügen',
    updateRedirect: 'Weiterleitung aktualisieren',
    editRedirect: 'Weiterleitung bearbeiten',
    currentRedirects: 'Aktuelle Weiterleitungen',
    noRedirects: 'Noch keine Weiterleitungen konfiguriert.',
    redirectPermanent: 'Permanent ({{code}})',
    redirectTemporary: 'Temporär ({{code}})',
    redirectAdded: 'Weiterleitung hinzugefügt',
    redirectUpdated: 'Weiterleitung aktualisiert',
    redirectRemoved: 'Weiterleitung entfernt',
  },
  aiAssistant: {
    title: 'Bauen Sie Ihre Website mit Ihrem KI-Assistenten',
    pitch:
      'Nutzen Sie das ChatGPT oder Claude, das Sie schon haben: Es stellt Ihnen Fragen, baut Ihre Seite, und Sie laden eine Datei hoch. Ausprobieren ist gratis; Sie zahlen erst, wenn die Seite online gehen soll.',
    step1Title: 'Kopieren Sie diese Zeile und fügen Sie sie bei Ihrem Assistenten ein',
    oneLiner: 'Lies {{url}} und hilf mir, meine Website zu bauen.',
    step1Description: 'Ihr Assistent liest unsere Anleitung auf dieser Seite. Nichts zu installieren, nichts zu verbinden.',
    copy: 'Kopieren',
    copiedShort: 'Kopiert',
    copied: 'Die Zeile ist in Ihrer Zwischenablage. Fügen Sie sie bei Ihrem Assistenten ein.',
    copyFailed: 'Kopieren nicht möglich. Markieren Sie die Zeile und kopieren Sie sie von Hand.',
    step2Title: 'Beantworten Sie seine Fragen und laden Sie die index.html herunter, die es Ihnen gibt',
    step2Description:
      'Es fragt, wofür die Website ist, nach Ihrem Namen, Ihrem Angebot und wie man Sie erreicht, baut dann die Seite und zeigt sie Ihnen. Wünschen Sie Änderungen, bis sie Ihnen gefällt, und laden Sie dann die Datei herunter.',
    step3Title: 'Erstellen Sie eine Site bei YWT und laden Sie diese Datei hoch',
    step3Description:
      'Erstellen Sie unter Website-Hosting eine Site und wählen Sie im Tab «Bearbeiten» «Mit Ihrem KI-Assistenten bauen». Vorschau und Entwurfslink gehen sofort. Um die Seite auf Ihre Domain zu bringen, veröffentlichen Sie sie mit dem Starter-Plan.',
    goToHosting: 'Website-Hosting',
    seePlans: 'Zu den Plänen',
    tabsTitle: 'Wo Sie die Zeile einfügen',
    chatgptOpen: 'Öffnen Sie ChatGPT (chatgpt.com oder die Desktop-App) und starten Sie einen neuen Chat.',
    claudeOpen: 'Öffnen Sie Claude (claude.ai oder die Desktop-App) und starten Sie einen neuen Chat.',
    pasteAndEnter: 'Fügen Sie die Zeile ein und drücken Sie Enter.',
    noBrowsingHint: 'Sagt es, dass es die Seite nicht öffnen kann, nutzen Sie unten «Vollständigen Prompt kopieren» und fügen Sie stattdessen diesen ein.',
    chatgptResult: 'Die fertige Seite kommt als Datei zum Herunterladen. Speichern Sie sie als index.html.',
    claudeResult: 'Die fertige Seite erscheint als Artefakt neben dem Chat. Nutzen Sie dessen Download-Knopf und speichern Sie sie als index.html.',
    fullPromptTitle: 'Ihr Assistent kann keine Links öffnen?',
    fullPromptDescription: 'Kopieren Sie stattdessen den vollständigen Start-Prompt (auf Englisch) und fügen Sie ihn im Chat ein. Er funktioniert gleich.',
    copyFullPrompt: 'Vollständigen Prompt kopieren',
    fullPromptCopied: 'Der vollständige Prompt ist in Ihrer Zwischenablage. Fügen Sie ihn bei Ihrem Assistenten ein.',
    fullPromptFailed: 'Der Prompt konnte nicht geladen werden. Wir haben die Doku-Seite in einem neuen Tab geöffnet; kopieren Sie ihn dort.',
    openDocs: 'In der Doku lesen',
    faqPhotosQ: 'Was ist mit Fotos?',
    faqPhotosA: 'Ihr Assistent sieht Ihre Fotos nicht und lässt darum an jeder Stelle einen Platzhalter. Fügen Sie die Fotos nach dem Hochladen im Editor im Tab «Bearbeiten» ein.',
    faqChangesQ: 'Wie ändere ich später etwas?',
    faqChangesA: 'Laden Sie Ihre index.html im Tab «Bearbeiten» herunter, geben Sie sie Ihrem Assistenten und sagen Sie, was sich ändern soll. Dann laden Sie die neue Datei auf demselben Weg hoch.',
    faqCostQ: 'Was kostet das?',
    faqCostA: 'Die Seite bauen und einen Entwurfslink teilen ist gratis, ebenso Ihr YWT-Konto. Um sie im Internet auf Ihrer eigenen Domain zu veröffentlichen, brauchen Sie den Starter-Plan.',
  },
  consent: {
    title: 'Analyse-Cookies',
    body: 'Dürfen wir Analyse-Cookies verwenden? Sie helfen uns zu sehen, was auf dieser Website funktioniert und was nicht.',
    accept: 'Gerne',
    decline: 'Nein danke',
    settings: 'Cookie-Einstellungen',
  },
  footer: {
    productOf: 'ist ein Produkt der Cuspar GmbH, © Cuspar GmbH {{year}}',
    swissMadeSoftware: 'Swiss Made Software',
  },
  admin: {
    domainSynced: '{{domain}} synchronisiert',
    domainsSynced: '{{count}} Domain(s) synchronisiert',
    filterDomainsPlaceholder: 'Nach Domain oder Kunden-E-Mail filtern…',
    domainsShown: '{{shown}} / {{total}}',
    syncAllShown: 'Alle angezeigten synchronisieren ({{count}})',
    sync: 'Synchronisieren',
    domains: 'Domains',
    users: 'Benutzer',
    subscriptions: 'Statisches Hosting-Abonnements',
    user: 'Benutzer',
    registrar: 'Registrar',
    expires: 'Läuft ab',
    autoRenew: 'Automatische Verlängerung',
    ywtDns: 'YWT DNS',
    deleted: 'Gelöscht',
    renewals: 'Verlängerungen',
    urlForwarding: 'URL-Weiterleitung',
    rules: '{{count}} Regel(n)',
    staticSite: 'Statische Website',
    orders: 'Bestellungen',
    websites: 'Websites',
    subscription: 'Abonnement',
    none: 'Keine',
    impersonate: 'Identität annehmen',
    deleteUser: 'Konto löschen',
    deleteUserTitle: 'Konto von {{email}} löschen?',
    deleteUserDescription:
      'Dies kann nicht rückgängig gemacht werden. Profil, Login, Kontakte, gespeicherte Zahlungsmittel, Warenkorb, unbezahlte Bestellungen, Websites ({{sites}}), DNS-Zonen und URL-Weiterleitungen des Kunden werden endgültig gelöscht, und der Kunde wird per E-Mail benachrichtigt.',
    deleteUserSubscription: 'Das aktive Hosting-Abonnement endet sofort und ohne Rückerstattung.',
    deleteUserRetention: 'Bezahlte Bestellungen ({{count}}) werden gemäss Schweizer Recht zehn Jahre aufbewahrt.',
    deleteUserBlockedDomains: 'Auf diesen Kunden sind bei uns noch Domains registriert. Sie müssen zuerst wegtransferiert oder gelöscht werden:',
    deleteUserBlockedOrder: 'Eine Bestellung des Kunden wird noch verarbeitet. Versuchen Sie es erneut, sobald sie abgeschlossen ist.',
    deleteUserBlockedAdmin: 'Admin-Konten können nicht gelöscht werden.',
    deleteUserConfirmLabel: 'Geben Sie zur Bestätigung die E-Mail-Adresse des Kunden ein',
    deleteUserSuccess: 'Das Konto von {{email}} wurde gelöscht.',
    owner: 'Besitzer',
    tier: 'Stufe',
    interval: 'Intervall',
    start: 'Start',
    cancelAtEnd: 'Am Ende kündigen',
    eppAdmin: 'EPP-Admin',
    general: 'Allgemein',
    auth: 'Authentifizierung',
    poll: 'Abfrage',
    statistics: 'Statistiken',
    resources: 'Ressourcen',
    domain: 'Domain',
    contact: 'Kontakt',
    host: 'Host',
  },
  subscription: {
    calculatingPlanChange: 'Planänderung wird berechnet...',
    upgradeTo: 'Auf {{tier}} upgraden',
    upgradeImmediate: 'Sie erhalten sofortigen Zugang zu allen {{tier}}-Funktionen.',
    planUpgrade: '{{tier}}-Plan-Upgrade',
    daysUntil: '{{days}} Tage bis {{date}}',
    prorationExplanation: 'Dies ist die Preisdifferenz zwischen {{currentTier}} und {{newTier}} für Ihren verbleibenden Abonnementzeitraum.',
    whatYouGet: 'Was Sie erhalten:',
    upToWebsites: 'Bis zu {{count}} Websites (derzeit {{current}})',
    upToCustomDomains: 'Bis zu {{count}} benutzerdefinierte Domains pro Website (derzeit {{current}})',
    redirectToPayment: 'Sie werden zur Zahlung weitergeleitet.',
    createOrder: 'Bestellung erstellen',
    downgradeTo: 'Auf {{tier}} downgraden',
    downgradeAtEnd: 'Ihr Plan wird am Ende des aktuellen Abrechnungszeitraums geändert.',
    cannotDowngradeYet: 'Downgrade noch nicht möglich:',
    planChangesOn: 'Plan ändert sich am <strong>{{date}}</strong>',
    continueAccess: 'Sie haben bis dahin weiterhin Zugang zu allen {{tier}}-Funktionen.',
    afterDowngrade: 'Nach dem Downgrade:',
    maxWebsites: 'Maximal {{count}} Website(s)',
    maxCustomDomains: 'Maximal {{count}} benutzerdefinierte Domain(s) pro Website',
    noRefund: 'Es erfolgt keine Rückerstattung. Sie können diese geplante Änderung jederzeit vor Ende Ihres Abrechnungszeitraums stornieren.',
    scheduleDowngrade: 'Downgrade planen',
    upgradeComplete: 'Upgrade abgeschlossen!',
    downgradeScheduled: 'Downgrade geplant',
    nowHaveAccess: 'Sie haben jetzt Zugang zu allen {{tier}}-Funktionen. Viel Spass!',
    planWillChange: 'Ihr Plan wird am {{date}} auf {{tier}} geändert.',
    somethingWentWrong: 'Etwas ist schiefgelaufen',
    done: 'Fertig',
    downgradeToast: 'Downgrade auf {{tier}} für {{date}} geplant',
    changingTo: 'Wechsel zu <strong>{{tier}}</strong> am {{date}}',
    scheduledChangeCancelled: 'Geplante Änderung storniert',
    failedToCancelChange: 'Geplante Änderung konnte nicht storniert werden',
    failedToCalculate: 'Planänderung konnte nicht berechnet werden',
    failedToCreateOrder: 'Upgrade-Bestellung konnte nicht erstellt werden',
    failedToSchedule: 'Downgrade konnte nicht geplant werden',
    validationFailed: 'Validierung fehlgeschlagen',
    // FreePlanDialog
    freePlan: 'Kostenloser Plan',
    yourPlan: 'Ihr Plan',
    freeLabel: 'Kostenlos',
    freePlanDescription: 'Mit dem kostenlosen Plan können Sie einen Entwurf erstellen und teilen. Veröffentlichen stellt ihn unter Ihrer Domain ins Internet und erfordert einen Plan.',
    usage: 'Nutzung',
    websites: 'Websites',
    customDomains: 'Benutzerdefinierte Domains',
    notAvailable: 'Nicht verfügbar',
    freePlanLimitations: 'Einschränkungen des kostenlosen Plans',
    publishNeedsPlan: 'Veröffentlichen erfordert einen Plan',
    noCustomDomain: 'Keine benutzerdefinierte Domain',
    upgradeToUnlock: 'Upgraden zum Freischalten',
    permanentPublicUrl: 'Permanente öffentliche URL',
    customDomainSupport: 'Unterstützung für benutzerdefinierte Domains',
    fastSecureDelivery: 'Schnelle, sichere Auslieferung mit HTTPS',
    viewPlansAndPricing: 'Pläne & Preise anzeigen',
    // GoLiveDialog
    readyToGoLive: 'Bereit zum Veröffentlichen?',
    goLiveDescriptionWithName: 'Mit dem kostenlosen Plan können Sie "{{name}}" als Entwurf erstellen und teilen. Veröffentlichen stellt ihn unter Ihrer Domain ins Internet und erfordert einen Plan.',
    goLiveDescription: 'Mit dem kostenlosen Plan können Sie einen Entwurf erstellen und teilen. Veröffentlichen stellt ihn unter Ihrer Domain ins Internet und erfordert einen Plan.',
    whatsIncluded: 'Was enthalten ist:',
    draftModeNotice: 'Ihre Website ist ein <strong>Entwurf</strong>. Nur wer den Vorschau-Link von Ihnen erhält, kann sie sehen. Veröffentlichen macht sie öffentlich.',
    // ExpiredPlanDialog
    renewPlan: 'Plan erneuern',
    expired: 'Abgelaufen',
    ends: 'Endet',
    expiredDescription: 'Ihr Abonnement ist abgelaufen. Erneuern Sie es, um Ihre Websites weiterhin zu nutzen.',
    expiredNotice: 'Ihr {{tier}}-Plan ({{interval}}) ist am {{date}} abgelaufen.',
    expiredWarning: 'Ihre Websites werden bald nicht mehr öffentlich zugänglich sein. Erneuern Sie Ihr Abonnement, um den Zugang wiederherzustellen.',
    plan: 'Plan',
    billing: 'Abrechnung',
    monthly: 'Monatlich',
    yearly: 'Jährlich',
    expiredOn: 'Abgelaufen am',
    renewTierPlan: '{{tier}}-Plan erneuern',
    renewCheckoutNotice: 'Sie werden zur Kasse weitergeleitet, um die Zahlung abzuschliessen. Ihr Abonnement wird ab heute um {{period}} verlängert.',
    oneMonth: '1 Monat',
    // PlanManagementDialog
    managePlan: 'Plan verwalten',
    managePlanDescription: 'Sehen Sie Ihre Abonnementdetails ein und verwalten Sie Ihren Plan.',
    cancelledNotice: 'Ihr Abonnement endet am <strong>{{date}}</strong>. Es wird keine weitere Belastung erfolgen.',
    billedInfo: 'Abgerechnet {{interval}} \u00b7 {{action}} am',
    planFeatures: 'Plan-Funktionen',
    websitesCount: '{{count}} Website(s)',
    customDomainsCount: '{{count}} benutzerdefinierte Domain(s)',
    upgradeToBusiness: 'Auf Business upgraden',
    downgradeToStarter: 'Auf Starter downgraden',
    upgradeHint: 'Jederzeit upgraden. Zahlen Sie nur die Preisdifferenz für die verbleibenden Tage.',
    downgradeHint: 'Das Downgrade wird am Ende Ihres Abrechnungszeitraums wirksam.',
    cancelSubscription: 'Abonnement kündigen',
    cancelSubscriptionTitle: 'Ihr Abonnement kündigen?',
    cancelSubscriptionDescription:
      'Ihr Abonnement bleibt bis <strong>{{date}}</strong> aktiv. Danach verlieren Sie den Zugang zu Ihren Websites und benutzerdefinierten Domains. Bis dahin können Sie es hier jederzeit fortsetzen.',
    keepSubscription: 'Abonnement behalten',
    yesCancel: 'Ja, kündigen',
    cancelSubscriptionSuccess: 'Kündigung des Abonnements zum {{date}} geplant.',
    cancelSubscriptionFailed: 'Abonnement konnte nicht gekündigt werden',
    resumeSubscription: 'Abonnement fortsetzen',
    resumeSubscriptionTitle: 'Ihr Abonnement fortsetzen?',
    resumeSubscriptionDescription: 'Ihr {{tier}}-Plan verlängert sich am <strong>{{date}}</strong> automatisch, und Ihr Standard-Zahlungsmittel wird dann belastet.',
    resumeSubscriptionDismiss: 'Nicht jetzt',
    resumeSubscriptionSuccess: 'Abonnement fortgesetzt. Es verlängert sich am {{date}}.',
  },
  home: {
    swissAccreditedRegistrar: 'Schweizer akkreditierter Registrar',
    heroTitle: 'your web tech',
    heroSubtitle: '.ch/.li Domains registrieren - schnell, einfach und übersichtlich.',
    heroSubtitlePrice: '.ch- und .li-Domains für {{price}} pro Jahr, jedes Jahr.',
    sameRenewalPrice: 'Gleicher Preis bei jeder Verlängerung',
    freeTransfers: 'Kostenloser Transfer',
    comparePrices: 'Preise ansehen und vergleichen',
  },
  whois: {
    title: 'Whois-Abfrage',
    subtitle: 'Unterstützt alle TLDs. Minimal und schnell.',
    placeholder: 'Domainname eingeben, z.B. example.com',
    check: 'Prüfen',
    noData: 'Keine WHOIS-Daten für diese Domain verfügbar.',
    disclaimer: 'Whois-Abfragen sind nicht in Echtzeit und können bis zu 24 Stunden benötigen.',
    disclaimerTld: 'Je nach TLD sind möglicherweise nicht alle Informationen verfügbar.',
    summaryFor: 'Whois-Zusammenfassung für',
    domain: 'Domain:',
    status: 'Status:',
    nameServers: 'Nameserver:',
    created: 'Erstellt:',
    expires: 'Läuft ab:',
    updated: 'Aktualisiert:',
    whoisServer: 'WHOIS-Server:',
    dnssec: 'DNSSEC:',
    registrar: 'Registrar',
    registrant: 'Inhaber',
    administrative: 'Administrativ',
    technical: 'Technisch',
    billing: 'Rechnungskontakt',
    registrarName: 'Name:',
    registrarWebsite: 'Webseite:',
    registrarEmail: 'E-Mail:',
    registrarPhone: 'Telefon:',
  },
};
